var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _ellipse, _path29, _ellipse2, _path30, _ellipse3, _path31, _ellipse4, _path32, _path33, _path34, _path35, _rect, _path36, _path37, _circle, _circle2, _path38, _circle3, _circle4, _circle5, _rect2, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _g, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path98, _path99, _path100, _path101, _path102, _rect9, _path103, _path104, _path105, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _rect23, _rect24, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _g2, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _circle6, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _g3, _path143, _path144, _rect25, _rect26, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _g4, _path168, _path169, _path170, _path171, _path172, _path173, _g5, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _g6, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _g7, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _circle14, _circle15, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _polygon19, _polygon20, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _polygon21, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _rect27, _path262, _rect28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "0cdb4e4d-471b-45ef-b32c-d90d48ef90fc",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1135.7,
    height: 856.85,
    viewBox: "0 0 1135.7 856.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb74ba87-0e24-4c9d-a373-e17481b146a7",
    x1: 345.7,
    y1: 823.95,
    x2: 345.7,
    y2: 606.19,
    gradientTransform: "translate(636.4)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9ace95f1-7a40-47d7-848c-20f8f7c52f52",
    x1: -254.27,
    y1: 469.69,
    x2: -254.27,
    y2: 232.12,
    gradientTransform: "translate(1052.52 21.29) rotate(-2.2)",
    xlinkHref: "#bb74ba87-0e24-4c9d-a373-e17481b146a7"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "data trends") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M616.68,194.4c-71.4,11.92-142.91,5.5-211.75-3.38S267.41,170.8,195.86,173c-46,1.43-97.17,10.47-129,38.21-30.62,26.7-35,63.19-34.71,96.18.22,24.83,2.55,50.54,19.36,70.49,11.67,13.86,29.51,23.91,43,36.72,47,44.58,33.67,113.64,3.91,172.13-14,27.43-31.11,54.37-40.5,82.49S47.6,727.67,65.3,751c17.54,23.08,51.09,36.39,86,43.51,70.89,14.47,149.57,7,225.67-3.38C545.4,768,712,730.59,878,693.29c61.47-13.81,123.21-27.69,182.35-48,32.84-11.26,66.25-25.43,87.28-47.83,26.69-28.45,26.93-67.72.56-91.55C1104,466,1005,473.46,970.63,428c-18.94-25-11.23-58.61,3.24-88.17,31-63.4,91.75-125.65,83-189.36-6-43.76-48.38-80.39-104.68-90.52-59-10.62-134.41,7.11-167.78,50.61C750,155.34,679.72,183.88,616.68,194.4Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD",
    opacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.82,244.52s-14.07-5.72-58.81,14.81-50.33,17.92-61.92,14.78-18-3.88-30.46-21c0,0-8.75-47.48-17.23-54.83s-44.5,4.19-44.5,4.19-43.19,9.9-51.42-47.82c0,0,5.84-43.5-2.11-56.85,0,0,16,6.92,42.54-4.26s47.69,12,47.69,12,6.68,17.29,6,27.6,3.53,14.19,16.17,9.21c0,0,6.2-8.83-2.58-23.43s-15.06-25.46-12.61-36.79,9.5-27,32.17-34.91,53.44-9.37,68.22-15.52,18.35-10.16,18.35-10.16-9.09,9.11,12.32,47.73,7.77,55.38,7.77,55.38-11.4,27.15-61.7,24.95c0,0-48.47,1.77-22.05,22.32,0,0,16.93-3.44,42.23-11.49s43.57,25.16,48.1,48.26S1076.82,244.52,1076.82,244.52Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.66,50.86l.27-.07c1.94,7.37-19.72,37-38.24,60.52l-.22-.17C999.6,77.93,1013.16,56.52,1011.66,50.86Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M973.86,110.66l.11.3c-14.79,18.8-33.4,41.25-48.29,57.87-1.42,1.58-2.83,3.25-4.18,4.94l-.43-.34c1.36-1.7,2.78-3.37,4.2-5C940.16,151.85,959.07,129.45,973.86,110.66Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M921.43,173l.3.51c-27.1,33.83-28.89,86.36-29,86.81l-5.71-6.6C887.12,253.24,894.15,207.05,921.43,173Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.4,226.17s-32-16.61-56.86-10.65-81-21.07-81-21.07-23.8-9.67-28.59-20.69c0,0-16.33-17.27-17.26-26.21s-16.83-31.39-27.2-32.26",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.77,242.16s-16.09-10.84-14.22-23.48",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1016.08,256.16s-23-8.35-25.32-41.11",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M979,264.64s-22-18.24-14.69-50.12",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M934.33,255.73S919.68,225,932.72,205",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1045.77,205.92s-16.64,5.28-13.07,14",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1025.69,175.71s-22.26,7.07-22.79,38.57",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M994.63,168.44s-20.27,25-18.78,47.76",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M959.14,178.26S939,197.5,941.57,208.2",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M947,171.46s-18.88,3.38-21.52-2.81",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M922.46,148.67s9.54,12.63,12,9.8",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1017,140.68s-47.58,3.45-58.35-10.89",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M912.45,85s22.33,47.93,38.55,54",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M935.88,62.19s13.71,44.08,30.7,57.84",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1037,104.29s-36.19,15.54-57.92-.18",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M968.11,52.79S976.38,85.2,987.52,93",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1031.58,68s-20.34,7.7-27.93,1.8",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M905.05,159.26s-.06,28.25-7.7,30.25",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M842.17,195.86s30.54,2.61,44.63-13.15",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M897.16,125.88s-7.39,28.66-27.77,36.37",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M823.85,165.68s21.62,7.51,40.21-11.63",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M873.12,101.25s-2,24.34-15.27,35.72",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M824.67,128.6s17.94.12,22.15-5.73",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 675.84,
    cy: 808.62,
    rx: 353.51,
    ry: 16.83,
    fill: "#A2FADD",
    opacity: 0.1
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M216.76,842.28s-36.11-2.18-31.85,23.12c0,0-.84,4.47,3.21,6.5,0,0,.06-1.87,3.7-1.24a16.25,16.25,0,0,0,3.92.19,8.16,8.16,0,0,0,4.8-2h0s10.15-4.19,14.09-20.78c0,0,2.92-3.61,2.81-4.54l-6.1,2.6s2.09,4.39.45,8.05c0,0-.2-7.89-1.37-7.71-.24,0-3.17,1.53-3.17,1.53s3.59,7.65.88,13.22c0,0,1-9.44-2-12.67l-4.29,2.5S206,859,203.2,865.43c0,0,.72-9.89-2.25-13.75l-3.89,3s3.93,7.79,1.54,13.14c0,0-.32-11.52-2.38-12.39,0,0-3.4,3-3.92,4.23,0,0,2.69,5.66,1,8.64,0,0-1-7.67-1.86-7.71,0,0-3.39,5.09-3.74,8.57a18.44,18.44,0,0,1,2.92-9.06,10.17,10.17,0,0,0-5.19,2.69s.53-3.6,6-3.91c0,0,2.8-3.86,3.55-4.09,0,0-5.47-.46-8.78,1,0,0,2.92-3.39,9.78-1.85l3.84-3.13s-7.2-1-10.25.1c0,0,3.51-3,11.28-.81l4.18-2.5s-6.13-1.32-9.79-.85c0,0,3.86-2.08,11,.18l3-1.34s-4.49-.89-5.81-1-1.39-.51-1.39-.51a15.6,15.6,0,0,1,8.45.94S216.86,842.68,216.76,842.28Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.74,
    cy: 852.53,
    rx: 25.55,
    ry: 4.32,
    fill: "#A2FADD",
    opacity: 0.1
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M153.5,843.63s-20.35-1.23-17.95,13a3.48,3.48,0,0,0,1.81,3.67s0-1.06,2.09-.7a9.45,9.45,0,0,0,2.21.11,4.59,4.59,0,0,0,2.7-1.12h0s5.72-2.36,7.95-11.71c0,0,1.64-2,1.58-2.57l-3.44,1.47a6.13,6.13,0,0,1,.25,4.54s-.11-4.45-.77-4.34c-.13,0-1.78.85-1.78.85s2,4.32.49,7.46c0,0,.58-5.32-1.12-7.14l-2.42,1.41s2.36,4.46.76,8.09c0,0,.41-5.58-1.27-7.75l-2.19,1.71s2.22,4.39.87,7.41c0,0-.18-6.49-1.34-7a13.16,13.16,0,0,0-2.21,2.39s1.51,3.19.57,4.87c0,0-.57-4.33-1-4.34,0,0-1.91,2.86-2.11,4.83a10.49,10.49,0,0,1,1.65-5.11,5.81,5.81,0,0,0-2.93,1.51s.3-2,3.4-2.2a13.7,13.7,0,0,1,2-2.31,12.72,12.72,0,0,0-4.95.57s1.64-1.91,5.52-1l2.16-1.76s-4.06-.56-5.78,0c0,0,2-1.69,6.36-.46l2.36-1.4a21.24,21.24,0,0,0-5.52-.48s2.17-1.17,6.21.1l1.68-.76s-2.53-.5-3.28-.57-.78-.29-.78-.29a8.85,8.85,0,0,1,4.76.53S153.57,843.85,153.5,843.63Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.34,
    cy: 840,
    rx: 14.41,
    ry: 2.44,
    fill: "#A2FADD",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M192.25,813.39s-24.57-1.48-21.68,15.74a4.2,4.2,0,0,0,2.19,4.42s0-1.27,2.52-.84a11.3,11.3,0,0,0,2.67.13,5.56,5.56,0,0,0,3.26-1.35h0s6.91-2.85,9.6-14.14c0,0,2-2.46,1.9-3.1L188.57,816s1.41,3,.3,5.48c0,0-.13-5.37-.93-5.24-.16,0-2.16,1-2.16,1s2.44,5.21.6,9c0,0,.7-6.42-1.36-8.62l-2.92,1.71s2.85,5.38.92,9.77c0,0,.5-6.73-1.53-9.36l-2.64,2.07s2.67,5.3,1,8.94c0,0-.21-7.84-1.62-8.43a16.35,16.35,0,0,0-2.67,2.88s1.84,3.85.7,5.88c0,0-.7-5.22-1.27-5.25,0,0-2.3,3.46-2.54,5.84a12.65,12.65,0,0,1,2-6.17,6.91,6.91,0,0,0-3.53,1.83s.36-2.45,4.1-2.66c0,0,1.91-2.63,2.42-2.79,0,0-3.72-.31-6,.69,0,0,2-2.31,6.66-1.26l2.61-2.13s-4.9-.67-7,.07c0,0,2.39-2,7.67-.55L184.3,817a26.13,26.13,0,0,0-6.67-.57s2.63-1.42,7.5.12l2-.91s-3.06-.61-3.95-.7-1-.34-1-.34a10.6,10.6,0,0,1,5.75.64S192.33,813.66,192.25,813.39Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.18,
    cy: 813.48,
    rx: 17.39,
    ry: 2.94,
    fill: "#A2FADD",
    opacity: 0.1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M700.74,805.63v7.82H469.48v-6.36a76,76,0,0,0,5.23-140.37H699.17a76.13,76.13,0,0,0-42,50.4,76,76,0,0,0,29.41,80.47A76.11,76.11,0,0,0,700.74,805.63Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#d2d4de"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M699.17,666.72a76.13,76.13,0,0,0-42,50.4H516.73a76.13,76.13,0,0,0-42-50.4Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M204.68,626.89v43.89c0,24.25,17.74,43.9,39.63,43.9H924.69c21.89,0,39.63-19.65,39.63-43.9V626.89Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#d2d4de"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M700.74,805.63v7.82H469.48v-6.36a75.74,75.74,0,0,0,17.84-9.5H686.56A76.11,76.11,0,0,0,700.74,805.63Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 360.91,
    y: 778.46,
    width: 384.09,
    height: 23.17,
    rx: 9.5,
    ry: 9.5,
    fill: "#d2d4de"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M964.32,145.86a39.63,39.63,0,0,0-39.63-39.63H244.31a39.63,39.63,0,0,0-39.63,39.63V635.42H964.32Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#30374e"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M943.6,163.54V584.21a19.51,19.51,0,0,1-19.51,19.51H244.92a19.5,19.5,0,0,1-19.51-19.51V163.54A19.51,19.51,0,0,1,244.92,144H924.09A19.52,19.52,0,0,1,943.6,163.54Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#dfe3ef"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 552.35,
    cy: 103.56,
    r: 9.15,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 552.35,
    cy: 651.04,
    r: 22.56,
    fill: "#fff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M943.59,163.54H225.41A19.5,19.5,0,0,1,244.92,144H924.08A19.5,19.5,0,0,1,943.59,163.54Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.77,
    cy: 132.21,
    r: 4.88,
    fill: "#dfe3ef"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.4,
    cy: 132.21,
    r: 4.88,
    fill: "#dfe3ef"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.03,
    cy: 132.21,
    r: 4.88,
    fill: "#dfe3ef"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 260.88,
    y: 196,
    width: 579.62,
    height: 338.72,
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1034.42,674.83c.21-.57-1.38-3.77-1.38-3.93s-1.63-1.94-1.63-2.93-2.17-3.15-2.17-3.15-2.9-1.2-3.21-3.82-3.48-2.67-3.49-2.67h0s0-.24,0-.6a8.47,8.47,0,0,0-.38-3.07,3.12,3.12,0,0,0-1.8-1.52,6.76,6.76,0,0,0-1-2.67,3,3,0,0,1-.74-2.83c.32-1-.42-3.51-2-3.88s-3.27-.94-3.27-.94l-.42.07-.21-.07a10.31,10.31,0,0,1-1.11.14,1.4,1.4,0,0,1-.9-.3c-.53-.57-4.8-1.67-5.59-1.67a13.25,13.25,0,0,1-3.06-1l-2.27-1.73a14.81,14.81,0,0,1-2-2.74l0,0h0a11.19,11.19,0,0,1-.48-1.38h0a12.47,12.47,0,0,0,2-2.7l.15-.31a1.27,1.27,0,0,0,.34,0l.14-.06a2.22,2.22,0,0,0,1.12-1.34h0a2.19,2.19,0,0,0,.1-.34l0-.12a2,2,0,0,0,0-.24.59.59,0,0,0,0-.13,2,2,0,0,0,0-.24s0-.09,0-.13l0-.3h0c.05-.37.09-.74.17-1.11h0a21.08,21.08,0,0,1,1.78-3.94h0q.14-.28.24-.57c.08-.21.15-.43.21-.64a1.46,1.46,0,0,0,0-.2c0-.15.08-.31.11-.47s0-.14,0-.21c0-.22.06-.44.08-.66a8,8,0,0,0-.54-3.68c-.39-1-1-1.87-1.38-2.85-.61-1.49-.77-3.18-1.51-4.6a5.49,5.49,0,0,0-6.57-2.68c-1.15.43-2.14,1.26-3.31,1.63-1.56.5-3.22.12-4.84-.1s-3.4-.24-4.69.81c-1.5,1.21-1.91,3.49-3.31,4.83-.59.56-1.32.91-1.94,1.43a3.15,3.15,0,0,0-1,1.33l0,.11a1,1,0,0,0,0,.14.88.88,0,0,0,0,.16s0,.07,0,.11a2.61,2.61,0,0,0,0,.28h0a2.38,2.38,0,0,0,.05.26s0,0,0,.07a1.42,1.42,0,0,0,.07.22v0l.09.24.06.12a.3.3,0,0,0,0,.1,6.48,6.48,0,0,1,.49,1.22,1.37,1.37,0,0,1,0,.8,2.33,2.33,0,0,1-.59.77,11.06,11.06,0,0,0-2.38,3.81c-.06.16-.11.33-.17.49v0h.07a2.52,2.52,0,0,0,.46.1l.27,0a4.26,4.26,0,0,0,1.07-.08l.27-.06a6.31,6.31,0,0,0,1.07-.4c0,.11,0,.22,0,.33v.18a12.45,12.45,0,0,0,6.92,11.14c0,.11,0,.23,0,.34a2.7,2.7,0,0,1,0,.28l-.14-.13s-1-.47-1.85.89a6,6,0,0,1-2.59,2s-9.6,1.52-10,2.78l-4.48.26s-1.58.21-1.74,3.51-1,3.61-1,3.61-1.85,3.25-1.69,4.93a2.73,2.73,0,0,1-1.43,2.51l-.21,3a2,2,0,0,0-2.21,1.78,7.21,7.21,0,0,1-1.32,3s-2.9,2.41-3.06,4.45l-1.8,1.1s-4.16-.94-5.11-2.62l-.3-.27,0,0v0a14.23,14.23,0,0,0-1.74-1.54,1.29,1.29,0,0,1,.08.84l-.31-.34L941,666s-6.2-7.12-10.15-7.62h0a2.49,2.49,0,0,0-1.78,1.72c-.5,1.7-1,4.52.28,5.91l6.25,6.66.16.12,1.36,1.74c-.23.55-.43,1.08-.59,1.57v0c0,.11-.07.21-.1.31l0,.1-.09.29c0,.06,0,.12-.05.17l0,.1c-.15.53-.24.93-.29,1.16l-.35-.11.34.15v0a.45.45,0,0,0,0,.11l.32.14c1.85.81,11.07,4.85,11.55,5.47a6.67,6.67,0,0,0,7.17,1,7.56,7.56,0,0,0,3.85-4.24A44.77,44.77,0,0,0,962,676c.1-.62,2.48-1.36,2.48-1.36s.21,7-1,9.59S960,698.15,960,698.15a1.71,1.71,0,0,1,.45,0l-.13.66a1.57,1.57,0,0,1,.56,0c-.17,1.3-1.14,7.3-1.14,7.3a15.39,15.39,0,0,1-.84,3.67c-.53.94-.59,5.86-.59,5.86l-.84,3.57s.11.24.32.61v0a9,9,0,0,0,2.43,3.13,6.16,6.16,0,0,1-.43,1.63,5.78,5.78,0,0,0-.42,2.52,31.64,31.64,0,0,0-.79,5.19,19.52,19.52,0,0,1-.58,4l-1,9.12s-.63,7.9-.32,10a19.09,19.09,0,0,1-.21,5.08s.63,6.24.48,6.92-1,3.62-.48,5.24.21,6.08.21,6.08.32,5.87.69,7.75a13.26,13.26,0,0,1-.11,4.3,34.75,34.75,0,0,1-.53,4c-.15,0-1.53,2.78,1.27,5.51s1.06,2.3,1.06,2.3-2.22-1.1-2,1.15.6,1.59.63,1.53l-.52,1.72.37.05c-.1.12-.2.25-.31.37a8.15,8.15,0,0,1-1.06,1.1,2.3,2.3,0,0,0-.69,1.52,41.26,41.26,0,0,1-7.54,6.39,22.42,22.42,0,0,0-4.29,2.88c-.65.71-.54,1.29.81,1.73a20.45,20.45,0,0,0,11.44.21,13.35,13.35,0,0,0,5.6-3.61,8.07,8.07,0,0,1,4.48-.74c2.22.42,6.65-2.46,6.65-2.46l-.08-.74-.24-2.14a1.7,1.7,0,0,1-.37-1.31,7,7,0,0,0-.18-1.88c0-.21-.08-.42-.12-.61l.41-.08s-.53-2.67.42-3.19.68-7.39.68-7.39a8.4,8.4,0,0,0-1.84-1.83c-.63-.27-.06-3.52,0-3.93s1-8.55,1-8.55a11,11,0,0,1,.11-3.66c.42-1.1-.53-5.34-.53-5.34a1,1,0,0,1,.26-1.16c.58-.63.37-6.23.37-6.23s-.05-2.83-.05-3.57a12.93,12.93,0,0,1,1.21-4.29c.58-.89.22-3.67.22-3.67h0l0-.21c0-.08,0-.18,0-.3l0-.28a40.89,40.89,0,0,1,1-4.54c.69-2.2,1.48-6.08,1.48-6.08l4.91-12.79,0-.15a20.05,20.05,0,0,1,2.27,8.07,46.08,46.08,0,0,1,.42,5.92,69.66,69.66,0,0,0,.48,7.17s.68,8.49.68,8.86.85,6.91,1.38,7.91-.53,4-.85,4.35.1,8,.1,8-.79,6.08-.95,7.34-.79,6.08-.26,8,.32,2.14.32,2.14,1.9,1.94.79,2.1a2.9,2.9,0,0,0-2.11,3.82,49.81,49.81,0,0,0,2.32,5.61l.88-.18v.62l.06,3.12a18.48,18.48,0,0,1,.16,3.67c-.15.5-.37,2.85-.47,4.07,0,.45-.06.75-.06.75s0,2.78,5.86,1.94,6.91-3.14,6.91-3.14,0-.11,0-.29c.09-.53.28-1.66.43-2.28.21-.84-1.68-4.61-1.68-4.61s-.32-2.57-.85-3.15a2.7,2.7,0,0,1-.42-1.1c0-.21-.09-.43-.13-.64l.39.07s-.31-1.84.9-2.41a1.74,1.74,0,0,0,.74-2.31,17.63,17.63,0,0,1,.47-3.46,1.72,1.72,0,0,1,.42-1.67c.75-.74,1.32-5.87,1.32-5.87l.11-19.81a19.05,19.05,0,0,0-.05-4.92c-.43-1.42-.85-4.14-.27-4.88s.06-4.13.06-4.13,0-7.18.79-9,.53-13.05.53-13.05l.21-7.39s1.72-1.62,1.31-10.13c1.84-.11,3.91-.18,4.23.07.58.47,4.32,2.89,6.54,1.37a31.72,31.72,0,0,0,2.63-2.05l-.93-15.71c.58.88.94,1.46.94,1.46,0-2.2,6.22-9.33,6.22-9.33s5.8-7.49,7.07-8.38,3.75-5.6,3.75-5.6a22.5,22.5,0,0,1,1.26-2.62C1036.1,677.92,1034.2,675.41,1034.42,674.83Zm-13.62,5.5c-1.58.16-4.9,3.78-5,4.56a3.16,3.16,0,0,1-.7,1.41c0-.32,0-.64-.07-1-.38-4.63-.78-10.27-.6-10.81a31.41,31.41,0,0,0,.21-5.19h0l.06-.08c1.06,3.29,4.37,7.16,4.37,7.16s.58,1.68,1.26,1.73S1020.8,680.33,1020.8,680.33Z",
    transform: "translate(-32.15 -21.57)",
    fill: "url(#bb74ba87-0e24-4c9d-a373-e17481b146a7)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M936.21,679.14s1.93-10.09,8.12-10.14l4.52,9.3-3,2.08S939.28,680.59,936.21,679.14Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#65617d"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M948.85,678.3l-3,2.08a35.47,35.47,0,0,1-7.9-.66,9.89,9.89,0,0,1-1.72-.58s0-.06,0-.17a0,0,0,0,1,0,0,21.91,21.91,0,0,1,1.17-3.71c.19-.45.4-.92.64-1.38a9.32,9.32,0,0,1,3.92-4.3,5.19,5.19,0,0,1,2.06-.54h.28l.09.2,1.53,3.15Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.22,720.21s6.5-.62,7.07-.15,4.27,2.86,6.45,1.35.73-6.76.73-7-.21-7.64-.21-7.64l-3.9-5.25-4.89-9.21-10-1,.26,14.61,0,7.48Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#65617d"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.22,720.21s6.5-.62,7.07-.15,4.27,2.86,6.45,1.35.73-6.76.73-7-.21-7.64-.21-7.64l-3.9-5.25-4.89-9.21-10-1,.26,14.61,0,7.48Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M943,668.74s-.51,6.34-4.47,6.44c0,0-1.12-.67-2.62-1.8-3.48-2.6-9-7.59-7.46-12.24,2.18-6.65,12.79,5.62,12.79,5.62l.82.91Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fbbebe"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M943,668.74s-.51,6.34-4.47,6.44c0,0-1.12-.67-2.62-1.8l-.34-.43a5.15,5.15,0,0,0,2.16.58,2.9,2.9,0,0,0,2.83-1.78,21.58,21.58,0,0,0,1.1-2.52,8.09,8.09,0,0,0,.4-1.56Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M941.31,680.23l-.89-1.15-3-3.85-1.53-2a5.26,5.26,0,0,0,2.17.59,2.92,2.92,0,0,0,2.82-1.79,22.31,22.31,0,0,0,1.1-2.51c.49-1.41.48-2.13.31-2.37A14.75,14.75,0,0,1,944,668.7l0,0,.29.27.1.21,1.51,3s0,0,0,.13C946.07,673.3,946.58,679.37,941.31,680.23Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#e7effd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M972.46,814.07s-4.37,2.86-6.56,2.44a7.82,7.82,0,0,0-4.42.73,13.14,13.14,0,0,1-5.51,3.59c-3.53,1.19-8.47.72-11.28-.21-1.33-.44-1.44-1-.8-1.72a22.18,22.18,0,0,1,4.23-2.86,40.71,40.71,0,0,0,7.44-6.34,2.27,2.27,0,0,1,.67-1.51,8,8,0,0,0,1-1.09c.56-.66,1.08-1.35,1.08-1.35l12.85.41s.22.93.39,1.88a6.91,6.91,0,0,1,.18,1.87,1.69,1.69,0,0,0,.36,1.3l.23,2.12Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#65617d"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M999.34,817.65c-.16.63-.34,1.74-.43,2.27,0,.17,0,.28,0,.28s-1,2.29-6.81,3.12-5.77-1.92-5.77-1.92,0-.3.06-.74a38.1,38.1,0,0,1,.46-4,18.94,18.94,0,0,0-.16-3.64l-.06-3.1,0-2.16,9.56-1a19.63,19.63,0,0,0,.31,2.13,2.87,2.87,0,0,0,.42,1.09c.52.57.83,3.12.83,3.12S999.55,816.82,999.34,817.65Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#65617d"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M971.21,806.16s.22.93.39,1.88c-1.39.25-7.45,1.3-9,.57a23.38,23.38,0,0,0-5.41-1.3l.06-.21c.56-.66,1.08-1.35,1.08-1.35Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M996.42,808.87c-2.42-.42-7.74.58-9.83,1l0-2.16,9.56-1A19.63,19.63,0,0,0,996.42,808.87Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M1001.83,730l-.2,7.33s.26,11.18-.52,13-.78,8.89-.78,8.89.52,3.38-.06,4.11-.15,3.43.26,4.83a18.81,18.81,0,0,1,.05,4.89l-.1,19.66s-.57,5.09-1.3,5.82a1.68,1.68,0,0,0-.41,1.66,17.29,17.29,0,0,0-.47,3.44,1.72,1.72,0,0,1-.73,2.28c-1.2.58-.89,2.4-.89,2.4-2.85-.68-11,1.14-11,1.14a47.77,47.77,0,0,1-2.29-5.57,2.87,2.87,0,0,1,2.08-3.79c1.09-.16-.78-2.08-.78-2.08s.21-.26-.32-2.13.11-6.66.26-7.91l.94-7.27s-.42-7.65-.1-8,1.35-3.33.83-4.31-1.35-7.49-1.35-7.86-.68-8.79-.68-8.79-.62-5.87-.47-7.12a45.67,45.67,0,0,0-.41-5.87,20,20,0,0,0-2.24-8l-.05.15-4.84,12.69s-.78,3.85-1.45,6a39.89,39.89,0,0,0-1,4.52l0,.28c0,.11,0,.21,0,.29l0,.21h0s.37,2.75-.2,3.64a12.68,12.68,0,0,0-1.2,4.26c0,.73.05,3.54.05,3.54s.21,5.56-.36,6.18a1,1,0,0,0-.26,1.15s.93,4.21.52,5.3a10.92,10.92,0,0,0-.11,3.64s-.83,8.06-.93,8.48-.68,3.64-.05,3.9a8.34,8.34,0,0,1,1.81,1.82s.27,6.81-.67,7.33-.42,3.17-.42,3.17-7.54,1.46-9.25.62a23.94,23.94,0,0,0-5.41-1.3l.52-1.71c0,.06-.38.62-.62-1.51s1.92-1.15,1.92-1.15,1.72.42-1-2.28-1.4-5.46-1.25-5.46a34.21,34.21,0,0,0,.52-4,13.41,13.41,0,0,0,.11-4.27c-.37-1.87-.68-7.7-.68-7.7s.26-4.41-.21-6,.31-4.52.47-5.2-.47-6.86-.47-6.86a19.27,19.27,0,0,0,.21-5c-.31-2.14.31-10,.31-10l.94-9a19.45,19.45,0,0,0,.57-4,32.57,32.57,0,0,1,.78-5.14,5.78,5.78,0,0,1,.41-2.5,18.66,18.66,0,0,0,.73-4.47l5-11.44,2.44-10.09,33-.31s.12.88.32,2.47.48,3.94.79,6.84c.29,2.64.61,5.75.91,9.2C1003.91,728.06,1001.83,730,1001.83,730Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#3f3d56"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M998.77,639l-7.7,8.22s-9.88-4-8.84-5.3c.4-.53.34-2.18.11-4-.37-2.88-1.15-6.19-1.15-6.19s17.26-2.81,15.81.1a4.77,4.77,0,0,0-.11,3.45A12.67,12.67,0,0,0,998.77,639Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fbbebe"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M997,631.82c-.53,1.06-.79,1.17-.46,2.31-2.25,2.42-5.12,5.07-8.69,5.07a12.25,12.25,0,0,1-5.51-1.29c-.37-2.88-1.15-6.19-1.15-6.19S998.45,628.91,997,631.82Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.22,626.51a12.38,12.38,0,1,1-24.75,0v-.17a12.38,12.38,0,0,1,24.75.17Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fbbebe"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M1002,708.16c-1.63,0-7.09.06-13.19.15h-.08l-2,0h-.07c-7.23.11-14.36-1.3-17.22-1-6.08.57,2.18-5.62,2.18-5.62a50.77,50.77,0,0,0,13.86,1.4l1.75-.09c5.53-.31,11.09-.83,14-1.7C1001.42,702.92,1001.7,705.25,1002,708.16Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1002,707.84c-1.63,0-7.09.06-13.19.16h-.08l-2,0h-.07c-7.23.12-14.36-1.29-17.22-1-6.08.57,2.18-5.62,2.18-5.62a50.77,50.77,0,0,0,13.86,1.4l1.75-.09c5.53-.31,11.09-.83,14-1.7C1001.42,702.6,1001.7,704.94,1002,707.84Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#e3a79f"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M984.52,642.43,975,646.9,967.57,704s4.37-2,6.86-.73,10.19.11,10.19.11,5.62-.32,6.45.31,10.61-2.6,10.61-2.6,1.76-4,.41-4.58.42-6.76.42-6.76l-.83-41.18-1.67-5.3-4.47-2.7L991,644.19l-2.19.32Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M984.52,641.8,975,646.27l-7.38,57.1s4.37-2,6.86-.73,10.19.1,10.19.1,5.62-.31,6.45.31,10.61-2.6,10.61-2.6,1.76-4,.41-4.57.42-6.76.42-6.76l-.83-41.18-1.67-5.31-4.47-2.7L991,643.57l-2.19.31Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#e7effd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M984.36,644.45s2.76,3.28,2.71,4-.16,2.28-.16,2.28l-2.08,4.22s-1.14,5.25-1.14,6.34-1.82,10.55-1.82,10.55l-2.19,14.56-2.75,19.09,2.8,4.83,3.33-2.81,4.42-34,.94-6.71s1-12.06,1-13.31a41.73,41.73,0,0,0-.58-4.52s.68-3.12,3.49-3.85-.21-.16-.21-.16l-1.61-1.3-1.41.57S985.19,643,984.36,644.45Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M984.05,644.14s2.76,3.28,2.7,4-.15,2.29-.15,2.29l-2.08,4.21s-1.15,5.26-1.15,6.35-1.82,10.55-1.82,10.55l-2.18,14.56-2.76,19.08,2.81,4.84,3.33-2.81,4.42-34,.94-6.71s1-12.06,1-13.31a42.71,42.71,0,0,0-.57-4.53s.68-3.12,3.49-3.84-.21-.16-.21-.16l-1.61-1.3-1.41.57S984.88,642.69,984.05,644.14Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#3f3d56"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M982.23,638.68s-.42.32-.52,2.4a41.36,41.36,0,0,1-1.56,6.75s5.41-3.74,8.11-3.32Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M982.23,638.06s-.42.31-.52,2.39a41.28,41.28,0,0,1-1.56,6.76s5.41-3.74,8.11-3.33Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#e7effd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M997,637l-8.53,7.49s7.18,4.26,8.11,5.3,1.87-10.19,1.87-10.19Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M997.31,636.4l-8.53,7.48s7.18,4.27,8.11,5.31S998.77,639,998.77,639Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#e7effd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M982.54,638.68s-.93-.46-1.82.89a5.84,5.84,0,0,1-2.55,2s-9.46,1.51-9.82,2.76l-4.42.26s-1.56.21-1.72,3.48-1,3.59-1,3.59-1.82,3.22-1.66,4.89a2.71,2.71,0,0,1-1.4,2.49l6.5,16.9s.2,7-1,9.52-3.43,13.83-3.43,13.83.93-.21.88.41-1.14,7.44-1.14,7.44a15.13,15.13,0,0,1-.84,3.64c-.52.94-.57,5.82-.57,5.82l-.83,3.54s2,4.42,5,3.8,8.48-12.43,8.48-12.43l3.48-12.74,2.7-12.58.78-8.53,1.25-18.88,1.82-12.48S983.27,639.57,982.54,638.68Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M982.23,638.06s-.94-.47-1.82.88a5.81,5.81,0,0,1-2.55,2s-9.46,1.51-9.82,2.75l-4.42.26s-1.56.21-1.72,3.49-1,3.59-1,3.59-1.82,3.22-1.66,4.88a2.74,2.74,0,0,1-1.41,2.5l6.5,16.9s.21,7-1,9.51-3.44,13.84-3.44,13.84.94-.21.89.41-1.15,7.44-1.15,7.44a15,15,0,0,1-.83,3.64c-.52.93-.57,5.82-.57,5.82l-.83,3.54s2,4.42,5,3.79,8.48-12.43,8.48-12.43l3.48-12.73,2.7-12.59.78-8.53,1.25-18.87,1.82-12.48S983,638.94,982.23,638.06Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#65617d"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M948.85,678.3l-3,2.08a35.47,35.47,0,0,1-7.9-.66l-1.68-.75-.34-.14.35.11a6.87,6.87,0,0,0,4.16.14c4.27-1.43,3.8-8.48,3.63-10.07,0-.16,0-.27,0-.31h0l0,0a2.22,2.22,0,0,0,.19.27l.19.2h0l1.51,3s0,0,0,.13Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M959.3,658l-1.46.42-.2,3a2,2,0,0,0-2.19,1.77,7.2,7.2,0,0,1-1.3,3s-2.86,2.39-3,4.41l-1.77,1.1s-4.11-.94-5-2.6c0,0,1.87,13.41-8.12,10.14,0,0,11.18,4.88,11.7,5.56a6.55,6.55,0,0,0,7.07,1,7.55,7.55,0,0,0,3.8-4.21s3-4.22,3.12-4.84,2.44-1.35,2.44-1.35l4.48-10.82Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#65617d"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M995.8,643.26l1.51-6.86a8.19,8.19,0,0,0,1.35,2.75l2.24,1.72a12.92,12.92,0,0,0,3,1c.78,0,5,1.09,5.51,1.66s2.6.16,2.6.16,1.72.57,3.23.93,2.23,2.86,1.92,3.85a3,3,0,0,0,.73,2.81,6.75,6.75,0,0,1,.94,2.65,3,3,0,0,1,1.76,1.51,10.53,10.53,0,0,1,.37,3.64L1013.22,670a31.9,31.9,0,0,1-.21,5.14c-.31.94,1.09,16.85,1.09,16.85l1.62,27.35a30.49,30.49,0,0,1-2.6,2c-.47.21-.94-9.67-.94-10s-12-18-12-18a16.19,16.19,0,0,1-1.61-3.17c0-.57-1.51-5.82-1.51-5.82l-2.29-10.14Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1021.61,658.52c0,.36,0,.6,0,.6L1013.85,670h0a31.68,31.68,0,0,1-.2,5.14c-.18.55.21,6.14.58,10.74.26,3.32.51,6.11.51,6.11l.68,11.6.93,15.75a29,29,0,0,1-2.6,2c-.47.21-.94-9.67-.94-10s-12-18-12-18a16.19,16.19,0,0,1-1.61-3.17c0-.57-1.51-5.82-1.51-5.82l-2.28-10.14,1-31,.88-6.86a15,15,0,0,0,2,2.75l2.23,1.72a13,13,0,0,0,3,1c.78,0,5,1.09,5.51,1.66s2.6.16,2.6.16,1.71.57,3.22.93,2.24,2.86,1.93,3.85a3,3,0,0,0,.72,2.81,6.59,6.59,0,0,1,.94,2.65,3,3,0,0,1,1.77,1.51A8.53,8.53,0,0,1,1021.61,658.52Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#65617d"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M958.05,797.06c.26,0,11.18.42,11,2.19S958.05,797.06,958.05,797.06Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M960.5,800s7.33,1.19,5.4,2.29S960.5,800,960.5,800Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M987.74,795.92s12.17,1,10.35,2.39-6.14,1.56-6.34,1.61A56.07,56.07,0,0,1,987.74,795.92Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M986.29,801.28s6.76,1.14,7,2.44S986.29,801.28,986.29,801.28Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M990,770s6.19,1.46,6.55,2.45Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M966.16,774.45s-3.22.93-.1,2.8S966.16,774.45,966.16,774.45Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M980.46,724.48c.37,0,6-1.87,8-1a13.24,13.24,0,0,0,4.42.83Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M981.19,730.4l-.05.52-4.84,12.69s-.78,3.85-1.45,6a39.89,39.89,0,0,0-1,4.52l4.29-26.61Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M988.74,708l-2,0h-.07l-1.18-5.24,1.75-.09Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#3f3d56"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.27,701.65l-1.29,1.07-4.32,3.56s-11.7,6.24-14.93.31c-2.84-5.22,10.43-9,13.62-9.76l.68-.17Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fbbebe"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M963.3,650.54s2.29,1,2.81,2.49S963.3,650.54,963.3,650.54Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M956.23,666.14s-3.33,4.05-2,5.61S956.23,666.14,956.23,666.14Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1015.72,652.83s-3.12.31-3.23,3Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M986.81,695.46c.31-.31,7.48-10.92,9.15-10Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1000.22,626.51a12.4,12.4,0,0,1-1.46,5.85l-.09,0c-.79-.17-1.2-1.08-1.8-1.65a2.42,2.42,0,0,0-2.8-.39,2.82,2.82,0,0,0-1.38,2.66c-.4-1.66-.27-3.43-.66-5.1s-1.55-3.36-3.15-3.39c-.68,0-1.48.26-2-.26-.3-.31-.36-.8-.59-1.17-1.13-1.85-4.6-.91-6,0a36.81,36.81,0,0,1-4.82,3.27,12.38,12.38,0,0,1,24.75.17Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M986.31,622.72c.23.38.29.87.59,1.18.5.51,1.3.25,2,.26,1.59,0,2.75,1.72,3.14,3.39s.26,3.44.66,5.1a2.83,2.83,0,0,1,1.38-2.67,2.43,2.43,0,0,1,2.8.4c.6.57,1,1.48,1.8,1.65s1.54-.59,1.82-1.42a24.13,24.13,0,0,0,.45-2.59c.35-1.62,1.41-2.95,2-4.49a8.19,8.19,0,0,0-.06-5.81c-.39-1-1-1.85-1.36-2.83-.6-1.48-.76-3.15-1.49-4.56a5.37,5.37,0,0,0-6.47-2.66c-1.13.42-2.11,1.24-3.26,1.61-1.54.5-3.18.12-4.77-.1s-3.35-.24-4.63.81c-1.47,1.2-1.87,3.46-3.26,4.79-.58.55-1.3.91-1.91,1.42a2.6,2.6,0,0,0-1.07,2.11c.09,1.08,1.14,2.06.75,3.05a2.37,2.37,0,0,1-.57.76,10.87,10.87,0,0,0-2.52,4.29c2.78.87,5.79-2.2,8-3.65C981.71,621.81,985.18,620.88,986.31,622.72Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#3f3d56"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1013.27,701.65l-1.29,1.07c-1.14-1.9-5.83-5.7-5.83-5.7l.2-.19.68-.17Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.52,699.73s-.46,1.15-.95,2.16-1,1.91-1,1.17c-.06-1.46-6.09-6.35-6.09-6.35l.82-.8,1-.92Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#e7effd"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.73,692l.68,11.6c-1.61-2.51-6-9-8.9-8.74l6.92-7.95a10.36,10.36,0,0,0,.79-1C1014.48,689.24,1014.73,692,1014.73,692Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.52,699.73s-.46,1.15-.95,2.16c-1.81-2.49-4.3-5.43-6.29-6l1-.92Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.72,657.66l1.87,1.46s3.12,0,3.43,2.65,3.18,3.8,3.18,3.8,2.13,2.13,2.13,3.12,1.61,2.75,1.61,2.91,1.56,3.32,1.35,3.9,1.66,3.06,1.09,4a24,24,0,0,0-1.25,2.6s-2.44,4.68-3.69,5.56-7,8.32-7,8.32-6.14,7.07-6.14,9.26c0,0-6-10-9.52-9.72l6.92-8s1.2-1.3,1.25-2.08,3.33-4.37,4.89-4.52c0,0,.26-2.14-.42-2.19s-1.25-1.71-1.25-1.71-4.57-5.41-4.63-8.84S1019.72,657.66,1019.72,657.66Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#65617d"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.48,662.6s-4.37,3.23-3.44,4.27S1022.48,662.6,1022.48,662.6Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1022.68,675.91s8.11-2.6,9,0Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M972.46,814.07s-4.37,2.86-6.56,2.44a7.82,7.82,0,0,0-4.42.73,13.14,13.14,0,0,1-5.51,3.59c-3.53,1.19-8.47.72-11.28-.21-1.33-.44-1.44-1-.8-1.72,3.06.61,9.88,1.82,11.72.94a49.34,49.34,0,0,0,5.82-3.64s4.47-.63,5.1-.63a54.78,54.78,0,0,0,5.84-2.24Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M998.91,819.92c0,.17,0,.28,0,.28s-1,2.29-6.81,3.12-5.77-1.92-5.77-1.92,0-.3.06-.74C988.17,821.35,992.16,822.12,998.91,819.92Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M965.46,662s0,11.85-1,13S965.46,662,965.46,662Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M1012.34,665.8l1.5,4.24S1014.44,665.88,1012.34,665.8Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M975.57,620.35c.38-1-.62-1.93-.75-3a2,2,0,0,0-.16.94c.06.79.65,1.52.8,2.25A1.39,1.39,0,0,0,975.57,620.35Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.83,631.55c-.38-1.64-.27-3.38-.64-5s-1.56-3.35-3.15-3.38c-.69,0-1.49.25-2-.26-.3-.31-.36-.8-.59-1.18-1.14-1.84-4.6-.91-6,0-2.13,1.42-5.05,4.38-7.78,3.71a9.94,9.94,0,0,0-.35,1c2.78.87,5.79-2.2,8-3.65,1.42-1,4.89-1.88,6,0,.23.38.29.87.59,1.18.5.51,1.3.25,2,.26,1.59,0,2.75,1.72,3.14,3.39s.26,3.44.66,5.1A2.74,2.74,0,0,1,992.83,631.55Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.65,629.6c-.29.82-1,1.58-1.83,1.41s-1.19-1.08-1.79-1.65a2.45,2.45,0,0,0-2.81-.39,2.85,2.85,0,0,0-1.38,2.52,2.77,2.77,0,0,1,1.23-1.51,2.43,2.43,0,0,1,2.8.4c.6.57,1,1.48,1.8,1.65s1.54-.59,1.82-1.42a7.41,7.41,0,0,0,.29-1.49C1000.74,629.28,1000.7,629.44,1000.65,629.6Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.09,622.51c-.58,1.55-1.64,2.88-2,4.5a8.33,8.33,0,0,0-.16,1c.36-1.62,1.41-2.94,2-4.48a8,8,0,0,0,.48-2.16A8.34,8.34,0,0,1,1003.09,622.51Z",
    transform: "translate(-32.15 -21.57)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 315.35,
    y: 228.01,
    width: 74,
    height: 76.72,
    fill: "#dfe3ef"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 410.35,
    y: 228.01,
    width: 74,
    height: 76.72,
    fill: "#dfe3ef"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 505.35,
    y: 228.01,
    width: 74,
    height: 76.72,
    fill: "#A2FADD",
    opacity: 0.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 600.35,
    y: 228.01,
    width: 74,
    height: 76.72,
    fill: "#A2FADD",
    opacity: 0.2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 695.35,
    y: 228.01,
    width: 74,
    height: 76.72,
    fill: "#A2FADD",
    opacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 752.04,
    y: 235.59,
    width: 74,
    height: 76.72,
    transform: "translate(-37.64 509.97) rotate(-37.11)",
    fill: "#A2FADD",
    opacity: 0.1
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M384.5,257.54a12.36,12.36,0,1,0,12.36,12.35A12.35,12.35,0,0,0,384.5,257.54ZM393,273.22c-.48-.16-1.4-.21-1.75-.62-.17-.21-.06-1-.06-1a3.69,3.69,0,0,0,1.84-.36c.23-.14.13-.16,0-.36-.65-1.09-.36-2.47-.39-3.66a3,3,0,0,0-1.19-2.64,3.76,3.76,0,0,0-1.86-.41,4.14,4.14,0,0,0-1.5.24c-2.52,1-1,4.35-1.9,6.26-.15.33-.36.44,0,.63a4.64,4.64,0,0,0,1.72.37s0,.75,0,.83c-.07.29-.7.49-.94.56a7.3,7.3,0,0,0-1,.34.24.24,0,0,0,0,.45,4.35,4.35,0,0,1,.69.17,6.5,6.5,0,0,1,2.73,1.48,4.07,4.07,0,0,1,1.19,2.65.74.74,0,0,1-.33.69l-.34.21a.16.16,0,0,1-.25-.14,4,4,0,0,0-2.72-3.87c-.81-.28-1.67-.3-2.47-.58-.25-.08-.73-.19-.83-.46a3,3,0,0,1-.11-.88c0-.23,0-.46,0-.68s.38-.46.46-.6a4.55,4.55,0,0,0,.41-1.86c.52.14.58-.81.67-1.11s.3-1.24-.15-1.4a2.42,2.42,0,0,0,.25-.87,5.28,5.28,0,0,0-.07-2.34,3.69,3.69,0,0,0-3.52-2.46,3.77,3.77,0,0,0-3.77,2.25,4.92,4.92,0,0,0-.17,2.35,2.88,2.88,0,0,0,.28,1.07c-.38.17-.27,1-.2,1.27s.18,1.39.72,1.24a8.81,8.81,0,0,0,.23,1.44,2.06,2.06,0,0,0,.49.83c.1.12.16.13.15.28a6.1,6.1,0,0,1-.11,1.42c-.12.45-1.11.64-1.51.72a8.62,8.62,0,0,0-2.46.69,10.71,10.71,0,0,1,9.09-16.17,10.75,10.75,0,0,1,7.59,3.06,10.63,10.63,0,0,1,3.21,7.63,10.8,10.8,0,0,1-.86,4.23,2.75,2.75,0,0,0-1.33-.9Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M385.63,314.22V300.55l6.3,6.3,1.57-1.63-9-9-9,9,1.58,1.57,6.3-6.24v13.67Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD",
    opacity: 0.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M480.63,314.22V300.55l6.3,6.3,1.57-1.63-9-9-9,9,1.57,1.57,6.31-6.24v13.67Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD",
    opacity: 0.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M479.85,267.5a.27.27,0,0,0-.43,0l-5.13,6.81a.26.26,0,0,0,.18.43l9,.78a.26.26,0,0,0,.25-.39l-3.86-7.6Zm5.85,3.62a.27.27,0,0,0-.43,0l-1.38,1.4a.24.24,0,0,0,0,.3l1.42,2.76a.26.26,0,0,0,.2.13l2.51.21a.26.26,0,0,0,.25-.39l-2.54-4.38Zm.61-2.21a1.33,1.33,0,0,0,1.28-1.07,1.32,1.32,0,1,0-1.28,1.07Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M490.61,263.61l-3.67-.32-.34-3.74a1.52,1.52,0,0,0-1.65-1.37l-16.57,1.5a1.51,1.51,0,0,0-1.37,1.64l1.49,16.54a1.51,1.51,0,0,0,1.65,1.36l.87-.07-.08.93a1.5,1.5,0,0,0,1.38,1.63l16.58,1.45a1.52,1.52,0,0,0,1.64-1.38L492,265.24a1.5,1.5,0,0,0-1.38-1.63Zm-20.51,9.56a.39.39,0,0,1-.41-.34l-1-11.16a.37.37,0,0,1,.34-.41l15.57-1.4a.39.39,0,0,1,.41.34l.27,2.95-11.25-1a1.51,1.51,0,0,0-1.64,1.37l-.83,9.5-1.46.14Zm20.21-7.57-1,11.16a.38.38,0,0,1-.41.34l-1-.09-14.54-1.26a.38.38,0,0,1-.35-.41l.21-2.45.77-8.7a.37.37,0,0,1,.4-.35l11.05,1,1.65.15,2.88.25A.37.37,0,0,1,490.31,265.6Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 315.35,
    y: 380.14,
    width: 169,
    height: 126,
    fill: "#dfe3ef"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M451.39,440.41a59.35,59.35,0,0,0-78.72,56.08,4.21,4.21,0,0,1-8.42,0,67.78,67.78,0,0,1,89.61-64.14",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M453.86,432.35a67.87,67.87,0,0,1,45.89,64.14,4.21,4.21,0,1,1-8.42,0,59.44,59.44,0,0,0-39.94-56.08",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M438.24,466.53h-.07a7.37,7.37,0,0,0-6.17,3.38,7.37,7.37,0,0,0-6.17-3.38h-.07a7.34,7.34,0,0,0-7.28,7.34,15.79,15.79,0,0,0,3.11,8.63c3.91,5.35,10.41,10,10.41,10s6.5-4.68,10.41-10a15.79,15.79,0,0,0,3.11-8.63A7.34,7.34,0,0,0,438.24,466.53Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 530.96,
    y: 327.47,
    width: 256.39,
    height: 190.67,
    fill: "#dfe3ef"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 557.35,
    y: 470.95,
    width: 10.5,
    height: 35.19,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 577.35,
    y: 427.39,
    width: 10.5,
    height: 78.75,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 597.35,
    y: 388.14,
    width: 10.5,
    height: 118,
    fill: "#dfe3ef"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 617.35,
    y: 360.14,
    width: 10.5,
    height: 146,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 597.35,
    y: 360.14,
    width: 10.5,
    height: 146,
    fill: "#A2FADD"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 637.35,
    y: 425.89,
    width: 10.5,
    height: 80.25,
    fill: "#A2FADD"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 657.35,
    y: 405.14,
    width: 10.5,
    height: 101,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 677.35,
    y: 373.64,
    width: 10.5,
    height: 132.5,
    fill: "#fff"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 697.35,
    y: 447.14,
    width: 10.5,
    height: 59,
    fill: "#A2FADD",
    opacity: 0.2
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 717.35,
    y: 419.89,
    width: 10.5,
    height: 86.25,
    fill: "#A2FADD",
    opacity: 0.2
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 737.35,
    y: 388.14,
    width: 10.5,
    height: 118,
    fill: "#A2FADD",
    opacity: 0.2
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 757.35,
    y: 388.14,
    width: 10.5,
    height: 118,
    fill: "#A2FADD",
    opacity: 0.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "816.01 309.05 826.29 303.27 831.11 306.16 927.45 769.88 921.68 770.98 909.64 760.53 816.01 309.05",
    fill: "#65617d"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "826.29 303.27 921.68 770.98 927.45 769.88 831.11 306.16 826.29 303.27",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "755.38 328.62 828.7 335.64 828.7 341.31 755.77 334.96 755.38 328.62",
    fill: "#65617d"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "763.15 397.7 840.9 397.7 840.9 406 762.15 406 763.15 397.7",
    fill: "#65617d"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "770.28 470.13 848.77 467.01 858.59 470.13 858.59 475.45 788.85 479.12 770.92 479.12 770.28 470.13",
    fill: "#65617d"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "789.85 474.45 858.59 470.13 858.59 475.45 788.85 479.12 789.85 474.45",
    opacity: 0.1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "770.28 470.13 789.85 474.45 788.85 479.12 770.92 479.12 770.28 470.13",
    opacity: 0.1
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "777.39 548.74 864.05 540.7 873.6 543.19 873.6 548.74 796.19 556.87 777.39 558.54 777.39 548.74",
    fill: "#65617d"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "795.86 552.2 864.99 545.25 873.6 543.19 873.6 548.74 796.19 556.87 795.86 552.2",
    opacity: 0.1
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "776.23 553.22 795.86 552.2 796.19 556.87 777.39 558.54 776.23 553.22",
    opacity: 0.1
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "781.51 626.92 879.24 613.94 887.62 617.27 887.62 623.61 803.32 636.29 783.51 636.29 781.51 626.92",
    fill: "#65617d"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "803.32 632.28 887.62 617.27 887.62 623.61 803.32 636.29 803.32 632.28",
    opacity: 0.1
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "782.68 632.39 803.32 632.28 803.32 636.29 783.51 636.29 782.68 632.39",
    opacity: 0.1
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "787.28 707.42 894.48 687.43 903.97 693.01 903.97 697.42 809.91 720.24 790.52 721.71 787.28 707.42",
    fill: "#65617d"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "809.91 715.7 903.97 693.01 903.97 697.42 809.91 720.24 809.91 715.7",
    opacity: 0.1
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "789.39 716.73 809.91 715.7 809.91 720.24 790.52 721.71 789.39 716.73",
    opacity: 0.1
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "762.21 297.49 753.54 299.42 784.86 798.06 794.01 801.43 801.24 801.43 762.21 297.49",
    fill: "#65617d"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "757.98 298.43 794.01 801.43 801.24 801.43 762.21 297.49 757.98 298.43",
    opacity: 0.1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 761.09,
    y: 232.45,
    width: 74,
    height: 76.72,
    transform: "translate(-33.91 514.8) rotate(-37.11)",
    fill: "#fff"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 761.09,
    y: 232.45,
    width: 74,
    height: 76.72,
    transform: "translate(-33.91 514.8) rotate(-37.11)",
    fill: "#dfe3ef"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M815.47,291.92,807.23,281l8.82,1.22.27-2.25-12.6-1.75L802,290.85l2.2.31,1.26-8.78,8.25,10.9Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD",
    opacity: 0.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M796,268.09a11.59,11.59,0,0,1-18.45-11,.93.93,0,0,1,1.06-.78.94.94,0,0,1,.78,1.07,9.73,9.73,0,0,0,15.48,9.27,9.73,9.73,0,0,0-11-16l2.19,2.89a.94.94,0,0,1-1.49,1.13l-2.78-3.67a.94.94,0,0,1,.18-1.31,11.6,11.6,0,0,1,14,18.49Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M782.05,257.29l7.1-.17a1.75,1.75,0,1,1,.09,3.49,1.69,1.69,0,0,1-.56-.08l-6.79-2.1a.58.58,0,0,1-.38-.73A.59.59,0,0,1,782.05,257.29Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M872.18,493.32c-.74-2.68-1.22-5-1.22-5a10.54,10.54,0,0,0-1.37-5.11l0-.74h0l-.21-5.44a18.6,18.6,0,0,1,1.27-2.9c.91-1.75-.31-8-.31-8s-4-8.7-3.3-14.34-8.42-24.6-8.42-24.6a24.25,24.25,0,0,1,.57-5.54,4.26,4.26,0,0,0,.06-1.16.66.66,0,0,0,0-.14v0c-.27-3.69-3.46-10.51-3.46-10.51l-.11-13.22s1.56-7.86-1.88-18.19c-1.21-3.61-2-6.5-2.52-8.74-.06-.25-.11-.5-.16-.73,6.22-1.2,11-2.18,11-2.18s-4.22-15.06-6.78-17.62-4.84-10.85-4.84-10.85-1.69-10.69.25-13.91,2-8.64,2-8.64,4.58-3.6,5.11-5.14a25.15,25.15,0,0,0,1.31-6.81c-.07-1.8-.72-3.4-.56-4.35s-1.55-4.51-.83-6.25a4.5,4.5,0,0,0,.25-1.66s0,0,0-.05v0a23.3,23.3,0,0,0-.58-4.44,12.71,12.71,0,0,0-4.76-2.32l-.12-.4-.31-1.06a4.33,4.33,0,0,0-.47-.25l0-.39-.1-1.54.61-3.5c1.21-6.09-6.87-6.68-6.87-6.68A4.25,4.25,0,0,0,843,269c-1.64-.51.08,9.08.86,9.67a36.53,36.53,0,0,1,3.37,4.85h0l.14.24a3.45,3.45,0,0,0-.35.4l.39,2.08.06.32a8.36,8.36,0,0,0-1.2,2.24,4.7,4.7,0,0,1,1.31,3.37,10.8,10.8,0,0,0,.64,4.16c-.09-.09-1.17-1.18-2.19-.86s-3.88,1.29-3.88,1.29-2.15.46-1.93.93-1.37,2.62-1.37,2.62l-6-5.27c-.06-.17-.13-.33-.19-.5a13.81,13.81,0,0,1-.59-2.38,13.87,13.87,0,0,0,1.83-.67,4,4,0,0,0,1.57-1.09,6.25,6.25,0,0,0,.83-2.53,37.29,37.29,0,0,1,2-4.89,15.66,15.66,0,0,0,.83-8.67,5.76,5.76,0,0,0-1-2.49c-1-1.26-2.74-1.73-4-2.72s-2.15-2.55-3.64-3.27a6.94,6.94,0,0,0-4.42-.21A23.79,23.79,0,0,0,817.9,269a4.2,4.2,0,0,1-2.71,1,3.7,3.7,0,0,1-2-1.38s0-.06,0-.08l-.06-.08a10.13,10.13,0,0,0-.74,4.38q0,.34.06.69a1.94,1.94,0,0,0,0,.24,1.47,1.47,0,0,1,0,.21h0a1.71,1.71,0,0,1,0,.31,2.25,2.25,0,0,1-.52.8,5,5,0,0,0-.44.66,2.17,2.17,0,0,1,.07-.24,3.48,3.48,0,0,0-.54,1.86,1.89,1.89,0,0,0,.49,1.29,6.34,6.34,0,0,0,1,.72,10.43,10.43,0,0,0-.1,1.94,11.22,11.22,0,0,0,5.83,9.37c.08.16.15.32.22.49a13.92,13.92,0,0,1,1.3,6.28c0,.16,0,.31-.06.47l-.2.25h0s-9.57.46-11.91-1.5-5.5,5.21-5.5,5.21-3.41.8-4.12.16-4.72.09-4.72.09a8.67,8.67,0,0,0-6.07-2,17.77,17.77,0,0,0-4.49-2.27h0l-.12,0h0a5,5,0,0,0-2.17-.19s-4.86-3.71-6.32-5.75-8.29-9.54-8.33-9.57l0-.37-.12-1.13a3.43,3.43,0,0,1-.59.07l-.14-.38a20.74,20.74,0,0,0-1.52-3.14s0-1.43.35-1.8-.39-5.58-.39-5.58-4.62-9.76-8.14-2.2c0,0-7,5.07-.76,10.42,0,0,2.45,1.07,2.83,2,.25.6,1.13,2.24,1.72,3.33l.27.49-.07.06.13.93,0,.36c-1.11.69-1.85,1.36-1.65,1.84a10.55,10.55,0,0,1,.79,2.53s8.75,10.13,10,14.56c0,0,22.89,12.44,30.29,13.11l-1,6.69s-.24,4-.09,5.43-.58,7.92-.58,7.92-.91,9.55-1.94,10.92-.61,7.07-.61,7.07a47.93,47.93,0,0,1-1.16,8.13,20.68,20.68,0,0,0,0,8.09s-3.4,8.69,5.31,2.55c0,0,4.38-.44,9.42-.81,0,.17,0,.34,0,.51,0,.65,0,1.35,0,2.09.12,4.9.35,11.65.77,16.75.74,9,4.18,26.77,4.18,26.77l.34,9a13,13,0,0,0-.16,2.58,16.69,16.69,0,0,0,2.76,8.89l.92,6s1.77,3.88,1.89,6.23a3.48,3.48,0,0,1-.05.58,3.71,3.71,0,0,0,0,.92c0,2.72,1.9,9.16,1.9,9.16s.35,6.55,1.35,6.89-1,3.82-1.53,4.83c0-.06,0-.12,0-.18l-.11.2a4.81,4.81,0,0,0-.25,1.67,2.4,2.4,0,0,0,1.18,2.26c1.91,1.07,2.95,2,1.38,2.42a17,17,0,0,0-1.71.43c0-.07-.07-.15-.09-.21a1,1,0,0,0-.61,1.17,5,5,0,0,0,.67,2.2,23.91,23.91,0,0,0,2.85,4.74l.75-.11a3.76,3.76,0,0,1-.41.83,3.09,3.09,0,0,1-1.07,1,3.62,3.62,0,0,1-1.32.52,3.75,3.75,0,0,0-2.73,1.46c-.93,1.3-1.48,3.05.51,4.49l7.12,2.15S838.7,500.67,838,498s-1.23-5-1.23-5a10.85,10.85,0,0,0-1.16-4.77,6.36,6.36,0,0,0-.46-.69l.43-.06s.65-6,1.78-7.21c.27-.27.32-.48.25-.63.11-.33-.21-.51-.61-.6,0,.08-.05.15-.07.24a6,6,0,0,0-1.18-.09s-.51-3.12.72-4.31a1.2,1.2,0,0,0,.21-.94,5.07,5.07,0,0,0-.18-1.27.25.25,0,0,0,0,.07,46.5,46.5,0,0,0-3.11-7.25s-.2-2.85.54-4-.7-15.48-.7-15.48,0-6.95-1-10.15.81-7.07.81-7.07l0-.2,0,0s-.06-.43-.16-1.09l0,.07c-.27-1.83-.77-5.14-1.11-6.67-.47-2.17-.38-12.64-.38-12.64l1.59-4.53,3.44,7.57,3.73,10.13a8.77,8.77,0,0,1,1.86,4.3c0,.11,0,.22,0,.32a5.35,5.35,0,0,0,0,.69,6.15,6.15,0,0,0,1.16,3.62s1.07,4.81,2.49,6a5.49,5.49,0,0,1,1.51,3.56s1.94,7,2.77,8.17c.71,1,.85,3.88.88,4.75h0c0,.17,0,.26,0,.26s.32,2.5.4,4.62v.69A7.84,7.84,0,0,1,851,460a.36.36,0,0,0,0,.1c0-.12,0-.24,0-.36a17.82,17.82,0,0,0-.33,4.4c.05,2.53.55,5.51,2.15,7.21,2.77,2.94,4.42,2.49,4.42,2.49s-1.13,3.85-2.67,4.67a.61.61,0,0,0-.16.12,2.25,2.25,0,0,1,0-.22,1.82,1.82,0,0,0-.41,1.43,10.14,10.14,0,0,0,2.16,5.56,3.14,3.14,0,0,0,1.36.72l-.24.16a4,4,0,0,1-.53.28,2.85,2.85,0,0,1-.8.24,3.77,3.77,0,0,0-2.73,1.46c-.92,1.3-1.47,3.05.52,4.49l7.11,2.15S872.93,496,872.18,493.32Z",
    transform: "translate(-32.15 -21.57)",
    fill: "url(#9ace95f1-7a40-47d7-848c-20f8f7c52f52)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M826.24,499.58l-6.89-2.16c-1.93-1.44-1.4-3.19-.5-4.49a3.63,3.63,0,0,1,2.64-1.46,3.16,3.16,0,0,0,1.28-.51,3,3,0,0,0,1-1,5,5,0,0,0,.67-2.66s7.38-2.47,9.5-.36a5.22,5.22,0,0,1,1,1.29,11,11,0,0,1,1.13,4.76s.48,2.36,1.2,5S826.24,499.58,826.24,499.58Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#2d293d"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M859.37,495l-6.89-2.16c-1.93-1.45-1.4-3.2-.51-4.49a3.57,3.57,0,0,1,2.64-1.46,2.28,2.28,0,0,0,.77-.24,4.27,4.27,0,0,0,.51-.27c1.86-1.12,1.72-3.69,1.72-3.69s7.37-2.47,9.5-.36a5.25,5.25,0,0,1,.75.94,10.88,10.88,0,0,1,1.34,5.12s.47,2.36,1.19,5S859.37,495,859.37,495Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#2d293d"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M834,486.92a5.22,5.22,0,0,1,1,1.29h0l-11.13,1.73a5,5,0,0,0,.67-2.66S831.86,484.81,834,486.92Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M867.86,483.23l.08,2.09c-1.63,2.94-10.06,2.63-12.56,1.29a4.27,4.27,0,0,0,.51-.27c1.86-1.12,1.72-3.69,1.72-3.69s7.37-2.47,9.5-.36A5.25,5.25,0,0,1,867.86,483.23Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M868.84,474.16a19,19,0,0,0-1.22,2.9l.29,7.5c-1.78,3.21-11.7,2.55-13.1.89s-3-6.07-1.5-6.89,2.58-4.67,2.58-4.67-1.6.45-4.28-2.5-2.18-9.71-1.77-11.35-.27-7-.27-7-.05-3.8-.86-5-2.69-8.17-2.69-8.17a5.6,5.6,0,0,0-1.47-3.56c-1.38-1.18-2.42-6-2.42-6a6.28,6.28,0,0,1-1.11-4c.2-2.39-1.8-4.88-1.8-4.88l-3.63-10.14-3.33-7.58-1.54,4.53s-.08,10.47.39,12.64,1.26,7.95,1.26,7.95-1.76,3.87-.78,7.07,1,10.14,1,10.14,1.41,14.32.69,15.48-.51,4-.51,4,4.22,8.21,3,9.4-.69,4.31-.69,4.31,2.66-.11,1.56,1.08-1.72,7.2-1.72,7.2l-11.44,1.77a24.3,24.3,0,0,1-2.76-4.74c-1.65-3.46.17-3.15,1.68-3.59s.51-1.35-1.34-2.42-.9-3.68-.9-3.68,2.58-4.76,1.61-5.1-1.31-6.9-1.31-6.9-2.2-7.71-1.8-9.82-1.8-7.07-1.8-7.07l-.89-6a16.46,16.46,0,0,1-2.53-11.22l-.35-9.22s-3.35-17.76-4.08-26.77c-.46-5.77-.7-13.66-.81-18.59-.06-2.76-.08-4.59-.08-4.59L849,363.69a33.71,33.71,0,0,0,1,6.07c.5,2.24,1.27,5.13,2.44,8.74,3.35,10.34,1.84,18.2,1.84,18.2l.13,13.22s4,8.7,3.31,11.76a25.6,25.6,0,0,0-.55,5.54s8.82,19,8.18,24.62,3.21,14.34,3.21,14.34S869.73,472.41,868.84,474.16Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#575988"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M843.47,425.56l12.43-2.14S849.1,430.91,843.47,425.56Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.05
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M853.62,411.28s.6,4.4-2,6.17C851.58,417.45,856.39,416.5,853.62,411.28Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M852.32,397.25s-10.12,9-13.94,8.43S852.32,397.25,852.32,397.25Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M828.14,430.2s-7.86,2.11-8,5.3S828.14,430.2,828.14,430.2Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M831.41,469.75s-11.13,2.52-7.89,3.82a54.29,54.29,0,0,0,8.5,2.24S835.64,475.86,831.41,469.75Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.05
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M821.34,475.92a2.21,2.21,0,0,1-1.09-1.59l-.11.21s-.94,2.6.91,3.67l.6.37c.33-.08.69-.14,1-.24C824.19,477.9,823.19,477,821.34,475.92Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.75,474.6c.3-.29.26-1,0-2a5.36,5.36,0,0,0-.53,2.77A2.26,2.26,0,0,1,835.75,474.6Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832.21,427.4a13,13,0,0,0-.63,3.53,14.09,14.09,0,0,1,.78-2.44S832.3,428.07,832.21,427.4Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.68,421.43a4.82,4.82,0,0,0,.07-1.05c-.12.72-.19,1.38-.24,2C857.56,422,857.62,421.74,857.68,421.43Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.24,461.19a6.35,6.35,0,0,0,.2-2.12,7.29,7.29,0,0,0-.45,2.68A2.63,2.63,0,0,1,833.24,461.19Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.28,479a37.07,37.07,0,0,0-1.08,5.89l-11.44,1.77a24.3,24.3,0,0,1-2.76-4.74c-.15-.31-.26-.58-.36-.83-.67.34-.92,1.07.07,3.12a23.6,23.6,0,0,0,2.76,4.75l11.43-1.78s.63-6,1.72-7.2C837.16,479.41,836.79,479.14,836.28,479Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M820.44,462.54s.35,6.55,1.32,6.89h0c.44-1.11.72-2.15.29-2.3-1-.35-1.31-6.9-1.31-6.9s-2.2-7.71-1.81-9.82-1.79-7.07-1.79-7.07l-.9-6a16.44,16.44,0,0,1-2.52-11.23l-.36-9.21s-3.35-17.76-4.07-26.77c-.47-5.77-.7-13.66-.81-18.59,0-.89,0-1.68-.05-2.34l-.33,0s0,1.83.08,4.6c.11,4.92.35,12.81.81,18.58.73,9,4.08,26.77,4.08,26.77l.35,9.22A16.46,16.46,0,0,0,816,439.68l.89,6s2.19,5,1.8,7.07S820.44,462.54,820.44,462.54Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.1,482.9a11.19,11.19,0,0,1-2-4.45c-1.14,1.11.37,5.17,1.7,6.74s11.31,2.33,13.09-.88l-.07-1.81C865.36,485.14,856.42,484.47,855.1,482.9Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.13,471.61a17.81,17.81,0,0,0-1.22,2.9l.05,1.33a20.86,20.86,0,0,1,.88-1.94,5.84,5.84,0,0,0,.32-2.37Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.33,473.64a18.55,18.55,0,0,0,.85-2.3s-1.6.45-4.29-2.5c-1.95-2.14-2.21-6.31-2-9-.42,1.63-.92,8.41,1.76,11.35C853.36,473.06,854.64,473.54,855.33,473.64Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.56,452.76a50.54,50.54,0,0,1,.41,5.62c0-.37.11-.67.16-.89.42-1.63-.27-7-.27-7s-.06-3.8-.86-5-2.7-8.17-2.7-8.17a5.59,5.59,0,0,0-1.47-3.56c-1.37-1.18-2.41-6-2.41-6a6.17,6.17,0,0,1-1.11-4c.19-2.39-1.81-4.88-1.81-4.88l-3.62-10.14-3.34-7.58L831,405.61v1.45l1.25-3.68,3.34,7.58,3.62,10.13s2,2.49,1.81,4.88a6.21,6.21,0,0,0,1.1,4s1,4.81,2.42,6a5.57,5.57,0,0,1,1.47,3.55s1.89,7,2.69,8.18S849.56,452.76,849.56,452.76Z",
    transform: "translate(-32.15 -21.57)"
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M850.81,277.66l-.58,3.49.1,1.55.08,1.13-3.95.56-.48-.8h0a35.24,35.24,0,0,0-3.26-4.86c-.76-.59-2.44-10.18-.85-9.67a4.17,4.17,0,0,1,2.29,1.91S852,271.57,850.81,277.66Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#ffcdd3"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M850.41,283.83l-3.95.56-.48-.8h0a3.49,3.49,0,0,1,4.35-.89Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M851.48,285.67l-5.18,1.42-.14-.78-.38-2.08a3.61,3.61,0,0,1,5-.89l.3,1.06Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#dce6f2"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M766.51,281.28l-5.46,3.21-.55-1c-.57-1.09-1.43-2.74-1.67-3.33-.37-.91-2.74-2-2.74-2-6.06-5.36.72-10.42.72-10.42,3.4-7.55,7.89,2.21,7.89,2.21s.77,5.21.38,5.58-.34,1.8-.34,1.8a20.81,20.81,0,0,1,1.47,3.14C766.41,281,766.51,281.28,766.51,281.28Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#ffcdd3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M766.51,281.28l-5.46,3.21-.55-1c.76-.69,3.47-3.06,4.39-3a7.49,7.49,0,0,0,1.32,0C766.41,281,766.51,281.28,766.51,281.28Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M767.14,283,761,286.28l-.17-1.35-.13-.92s3.52-3.26,4.59-3.18a5.5,5.5,0,0,0,1.64-.07l.12,1.13Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#dce6f2"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M836.5,301.28s-27.22,4.14-22.18,2.28c3.52-1.29,4.84-3.61,5-6.13a14.37,14.37,0,0,0-1.26-6.29,26.85,26.85,0,0,0-2.63-4.84s20.46-12.3,16.68-1.69a16.85,16.85,0,0,0-1,5,14.06,14.06,0,0,0,.73,5A15,15,0,0,0,836.5,301.28Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#ffcdd3"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M832.15,284.61a16.85,16.85,0,0,0-1,5c-1.9,1.73-4.07,1.7-6.84,1.81-2.13.08-4.47.69-6.21-.28a26.85,26.85,0,0,0-2.63-4.84S835.93,274,832.15,284.61Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 791.39,
    cy: 259.28,
    r: 11.31,
    fill: "#ffcdd3"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M836.5,301.28s-27.22,4.14-22.18,2.28c3.52-1.29,4.84-3.61,5-6.13,1.31-1.52,4-2.69,5.74-3.33a8.21,8.21,0,0,1,4.95-.27,7,7,0,0,1,1.83.77A15,15,0,0,0,836.5,301.28Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M851.48,285.67l-5.18,1.42-.14-.78a4.62,4.62,0,0,1,5-1.91Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M767.14,283,761,286.28l-.17-1.35a46.47,46.47,0,0,1,6.22-3Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M850,369.76c-10.53,2.08-25.51,4.84-27.93,4.2-2-.53-8.34-.22-13.85.18-.06-2.76-.08-4.59-.08-4.59L849,363.69A33.71,33.71,0,0,0,850,369.76Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M860.43,366.87S825.79,374.2,822,373.2s-23,1-23,1c-8.42,6.13-5.14-2.56-5.14-2.56a21.14,21.14,0,0,1,0-8.09A49.25,49.25,0,0,0,795,355.4s-.41-5.69.58-7.06,1.86-10.92,1.86-10.92.7-6.5.56-7.92.07-5.43.07-5.43l1-6.69c-7.16-.68-29.33-13.15-29.33-13.15-1.22-4.42-9.7-14.56-9.7-14.56a10.72,10.72,0,0,0-.76-2.54c-.63-1.5,7.8-4.87,7.8-4.87s6.67,7.55,8.08,9.59,6.12,5.75,6.12,5.75a4.56,4.56,0,0,1,2.1.2.45.45,0,0,1,.11,0h0a16.91,16.91,0,0,1,4.35,2.28,8.24,8.24,0,0,1,5.87,2s3.88-.72,4.57-.08,4-.15,4-.15,3.05-7.16,5.32-5.2,11.53,1.51,11.53,1.51c1.17-1.69,4.13-3,6-3.67a8.22,8.22,0,0,1,4.95-.27,6.4,6.4,0,0,1,2,.87l5.83,5.29s1.54-2.15,1.33-2.62,1.87-.92,1.87-.92,2.72-1,3.75-1.29,2,.77,2.13.86a11,11,0,0,1-.64-4.15,4.75,4.75,0,0,0-1.27-3.38c3-8.3,10.78-1.75,10.78-1.75s1,4.44.33,6.18,1,5.29.81,6.24.48,2.55.55,4.36a25.92,25.92,0,0,1-1.26,6.8c-.51,1.55-4.94,5.14-4.94,5.14s-.07,5.43-2,8.64-.23,13.9-.23,13.9,2.23,8.29,4.7,10.86S860.43,366.87,860.43,366.87Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#656691"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M807.2,306.31s-1.17-3.09-2.13-3.34a22.45,22.45,0,0,1-2.8-1.13l.57-1.19s3.6.84,4.21,1.86S807.2,306.31,807.2,306.31Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M787.84,300.11c-.16,1-8.58,2.14-8.58,2.14l4.11-4.45h0l.11,0h0A16.91,16.91,0,0,1,787.84,300.11Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 730.72,
    cy: 266.44,
    r: 0.76,
    fill: "#575988"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 731.75,
    cy: 267.92,
    r: 0.76,
    fill: "#575988"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.76,
    cy: 269.29,
    r: 0.76,
    fill: "#575988"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 733.81,
    cy: 270.77,
    r: 0.76,
    fill: "#575988"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.36,
    cy: 267.24,
    r: 0.62,
    fill: "#575988"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.51,
    cy: 268.64,
    r: 0.62,
    fill: "#575988"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 823.65,
    cy: 270.03,
    r: 0.62,
    fill: "#575988"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M808.24,332.06c-.1-.11,22.36,26.11,38.39,9.84C846.63,341.9,820.49,346.48,808.24,332.06Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M796.47,346.59s12.83-.14,14.32,3.49l.14,3.84a2.43,2.43,0,0,1-2.38.09c-1.32-.65-9.22-4.29-11.88-2.29Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M796.71,346.58s12.27-.14,13.69,3.33l.14,3.66a2.35,2.35,0,0,1-2.28.08c-1.26-.61-8.82-4.08-11.36-2.18Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#656691"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M802.4,318.49a41.14,41.14,0,0,0,5.3,8.34,33.42,33.42,0,0,0,8.07,7.21S802.68,320.25,802.4,318.49Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M797.63,303.76s2.5,9.15,8.13,12.07Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M794.39,304.82c-.06-.17-1.62,7.37,7.54,11.16C801.93,316,798.06,314.83,794.39,304.82Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M850.11,296.48c-.14,0,4.56,2.75,5.85,4C856,300.53,852.81,296.18,850.11,296.48Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M820.87,291.22a2.45,2.45,0,0,0,.94,1.49,2.47,2.47,0,0,0,1.08.2c3.45.08,7.05.09,10.18-1.36a3.87,3.87,0,0,0,1.52-1.09,6.38,6.38,0,0,0,.81-2.53,35.55,35.55,0,0,1,1.9-4.89,16.18,16.18,0,0,0,.79-8.66,5.92,5.92,0,0,0-1-2.49c-1-1.27-2.65-1.74-3.9-2.73s-2.09-2.55-3.53-3.28a6.59,6.59,0,0,0-4.28-.21,22.55,22.55,0,0,0-7.85,3.29,3.94,3.94,0,0,1-2.62,1,3.66,3.66,0,0,1-2-1.42,10.44,10.44,0,0,0-.65,4.95,2.36,2.36,0,0,1,0,.75,2.25,2.25,0,0,1-.5.8c-.81,1-1.28,2.6-.4,3.57.38.42,1,.64,1.33,1.06.66.77.49,1.92.52,2.94a1.48,1.48,0,0,0,.28,1,1.45,1.45,0,0,0,1.41.28,4,4,0,0,1,1.48-.2,2.52,2.52,0,0,1,1.33.95A17.57,17.57,0,0,1,820.87,291.22Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#2d293d"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M834.93,289.58a3.86,3.86,0,0,1-1.51,1.09c-3.14,1.45-6.73,1.43-10.19,1.35a2.3,2.3,0,0,1-1.07-.2,2.35,2.35,0,0,1-.94-1.49,17.72,17.72,0,0,0-3.14-6.58,2.45,2.45,0,0,0-1.33-.94,3.79,3.79,0,0,0-1.48.2,1.49,1.49,0,0,1-1.41-.28,1.54,1.54,0,0,1-.29-1c0-1,.15-2.17-.52-2.94-.37-.43-.94-.64-1.33-1.07a2.22,2.22,0,0,1-.3-2.26,2.61,2.61,0,0,0,0,3c.39.42,1,.63,1.33,1.06.67.77.5,1.92.52,2.94a1.54,1.54,0,0,0,.29,1,1.44,1.44,0,0,0,1.41.28,4,4,0,0,1,1.48-.2,2.52,2.52,0,0,1,1.33.95,17.6,17.6,0,0,1,3.14,6.57,2.4,2.4,0,0,0,.94,1.5,2.43,2.43,0,0,0,1.07.2c3.46.08,7,.09,10.19-1.36a3.77,3.77,0,0,0,1.51-1.09,3,3,0,0,0,.46-.93Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.3,274a1.55,1.55,0,0,0,.32-.59,2,2,0,0,0,0-.74,10.57,10.57,0,0,1,.37-4.11l-.06-.07a10.45,10.45,0,0,0-.66,4.95A2.63,2.63,0,0,1,812.3,274Z",
    transform: "translate(-32.15 -21.57)"
  }))), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M819.12,298.15s14.2,1.33,15.38-.85",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M846.35,291.25s7.85-.3,9.69,2.58",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 860.86,
    y: 640.54,
    width: 74,
    height: 76.72,
    transform: "translate(-31.04 -23.05) rotate(0.09)",
    fill: "#fff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 860.86,
    y: 640.54,
    width: 74,
    height: 76.72,
    transform: "translate(-31.04 -23.05) rotate(0.09)",
    fill: "#fff"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M898.94,706.22l0-13.66,6.29,6.31,1.58-1.63-9-9-9,9,1.57,1.57,6.31-6.23,0,13.67Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD",
    opacity: 0.5
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M885.56,659.94h12.27V647.68c-.28,0-.59,0-.88,0a11.41,11.41,0,0,0-11.42,11.41C885.53,659.36,885.54,659.67,885.56,659.94Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#dfe3ef"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M889.8,668a11.42,11.42,0,1,0,9.78-18.53V661.7H887.32A11.38,11.38,0,0,0,889.8,668Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#dfe3ef"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M245.94,124.85c-6.45,13.32-17,28.49-28.93,22.69s-20.84-30.36-14.39-43.68S224,84.43,236,90.23,252.4,111.52,245.94,124.85Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M220.41,156s-2.33-.38-1.44-2.31a3.17,3.17,0,0,1,.28-.49,5.49,5.49,0,0,0,.76-1.79,5.79,5.79,0,0,0,.13-.68,9.1,9.1,0,0,0-.11-3.1l6.35-.42s-2.47,2.11-2.18,3.2a.68.68,0,0,0,.29.39,1.39,1.39,0,0,0,.42.18,4,4,0,0,1,.48.14c1.67.58,1,1.43,1,1.43C226.14,155.25,220.41,156,220.41,156Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M224.49,150.77l-4.48.61a5.79,5.79,0,0,0,.13-.68c1.13,0,2.92-.21,4.06-.32A.68.68,0,0,0,224.49,150.77Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M220.41,156s-2.33-.38-1.44-2.31a7,7,0,0,0,2.75.11,6.11,6.11,0,0,0,3.67-2.68c1.67.58,1,1.43,1,1.43C226.14,155.25,220.41,156,220.41,156Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M220.41,156s-2.33-.38-1.44-2.31a7,7,0,0,0,2.75.11,6.11,6.11,0,0,0,3.67-2.68c1.67.58,1,1.43,1,1.43C226.14,155.25,220.41,156,220.41,156Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M223.8,91.6s-7.1-.85-9.11,3.87a5.88,5.88,0,0,1,2.55.15,3.62,3.62,0,0,0,1.66.32A9.52,9.52,0,0,1,223.8,91.6Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff",
    opacity: 0.1
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M209.7,188.24a18.3,18.3,0,0,1-4,3.32c-.41.26-.84.52-1.28.76-11.31,6.22-31.3,6.33-40.67-1.93-8.75-7.71-11.77-19.27-8.37-28.72.17-.46.35-.91.55-1.37a21.79,21.79,0,0,1,3.63-5.69c7.11-8.06,19-9.7,29.19-4.84a25.83,25.83,0,0,1,2.63,1.43c.41.24.82.51,1.22.78a29.38,29.38,0,0,1,3,2.31c.52.46,1,.93,1.57,1.41l.13.12a78.17,78.17,0,0,1,8.87,9.44c.82,1.05,1.6,2.11,2.29,3.19.49.74,1,1.49,1.38,2.24a19.7,19.7,0,0,1,2.94,10c0,.32,0,.64-.07,1l0,.15a11.09,11.09,0,0,1-1.1,3.67A12.92,12.92,0,0,1,209.7,188.24Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M209.7,188.24a18.3,18.3,0,0,1-4,3.32c-.41.26-.84.52-1.28.76-11.31,6.22-31.3,6.33-40.67-1.93-8.75-7.71-11.77-19.27-8.37-28.72.17-.46.35-.91.55-1.37a21.79,21.79,0,0,1,3.63-5.69c7.11-8.06,19-9.7,29.19-4.84a25.83,25.83,0,0,1,2.63,1.43c.41.24.82.51,1.22.78a29.38,29.38,0,0,1,3,2.31c.52.46,1,.93,1.57,1.41l.13.12a78.17,78.17,0,0,1,8.87,9.44c.82,1.05,1.6,2.11,2.29,3.19.49.74,1,1.49,1.38,2.24a19.7,19.7,0,0,1,2.94,10c0,.32,0,.64-.07,1l0,.15a11.09,11.09,0,0,1-1.1,3.67A12.92,12.92,0,0,1,209.7,188.24Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M216.13,188a3,3,0,0,1-.4-.4,5.45,5.45,0,0,0-1.52-1.21,5.25,5.25,0,0,0-.63-.31,8.26,8.26,0,0,0-2-.6,7.17,7.17,0,0,0-1-.12l.9-4.3V181l.39-1.87a12,12,0,0,0,.9,1.57c.46.7,1,1.38,1.6,1.39a.73.73,0,0,0,.44-.18,1.23,1.23,0,0,0,.29-.36c.1-.16.18-.3.27-.43,1-1.44,1.63-.53,1.63-.53,1.14.41,1.61,1.76,1.78,3.13q0,.3.06.6a15.78,15.78,0,0,1-.1,2.91S217.75,189.37,216.13,188Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M214.21,186.38a5.25,5.25,0,0,0-.63-.31c.22-.93.49-2.34.68-3.43,0-.08,0-.15.05-.23s0-.23.06-.33a.73.73,0,0,0,.44-.18l-.09.68,0,.27Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M216.13,188a7.27,7.27,0,0,0,.84-2.63,5.61,5.61,0,0,0-.19-1.65c-.05-.17-.09-.32-.15-.48a4.93,4.93,0,0,0-1.26-2.12c1-1.44,1.63-.53,1.63-.53,1.14.41,1.61,1.76,1.78,3.13q0,.3.06.6a15.78,15.78,0,0,1-.1,2.91S217.75,189.37,216.13,188Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M216.13,188a7.27,7.27,0,0,0,.84-2.63,5.61,5.61,0,0,0-.19-1.65c-.05-.17-.09-.32-.15-.48a4.93,4.93,0,0,0-1.26-2.12c1-1.44,1.63-.53,1.63-.53,1.14.41,1.61,1.76,1.78,3.13q0,.3.06.6a15.78,15.78,0,0,1-.1,2.91S217.75,189.37,216.13,188Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M157.63,166.71s-2.72,6.61,1.29,9.82a5.72,5.72,0,0,1,.83-2.42,3.56,3.56,0,0,0,.75-1.52A9.48,9.48,0,0,1,157.63,166.71Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff",
    opacity: 0.1
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M259.42,146.87c-5.4,3.47-11.63,6.83-17.55,8.61-4.55,1.39-8.91,1.82-12.56.66a11.35,11.35,0,0,1-4.26-2.45,12.68,12.68,0,0,1-2.15-2.56c-4.23-6.61-4.15-18.23-.8-28.3,2.33-7,6.22-13.2,11.33-16.47,12.46-8,28.38-5.41,35.56,5.78S271.88,138.88,259.42,146.87Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M259.42,146.87c-5.4,3.47-11.63,6.83-17.55,8.61-4.55,1.39-8.91,1.82-12.56.66a11.35,11.35,0,0,1-4.26-2.45,12.68,12.68,0,0,1-2.15-2.56c-4.23-6.61-4.15-18.23-.8-28.3,2.33-7,6.22-13.2,11.33-16.47,12.46-8,28.38-5.41,35.56,5.78S271.88,138.88,259.42,146.87Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M228.26,160.24c-1.6,2.23-6.86-.15-6.86-.15s-1.79-1.55,0-2.72a3.87,3.87,0,0,1,.5-.27,5.94,5.94,0,0,0,1.59-1.13c.16-.17.32-.34.46-.52a8.94,8.94,0,0,0,1.13-1.76,7.14,7.14,0,0,0,.39-.94l5.64,3a12.79,12.79,0,0,0-1.77.43c-.81.26-1.61.65-1.76,1.16a.63.63,0,0,0,0,.48,1.19,1.19,0,0,0,.27.37,4.94,4.94,0,0,1,.33.37C229.31,159.89,228.26,160.24,228.26,160.24Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M227.59,157.78,223.46,156c.16-.17.32-.34.46-.52,1,.55,2.6,1.35,3.63,1.85A.63.63,0,0,0,227.59,157.78Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M228.26,160.24c-1.6,2.23-6.86-.15-6.86-.15s-1.79-1.55,0-2.72a7.25,7.25,0,0,0,2.3,1.53,6.05,6.05,0,0,0,4.52-.38C229.31,159.89,228.26,160.24,228.26,160.24Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M228.26,160.24c-1.6,2.23-6.86-.15-6.86-.15s-1.79-1.55,0-2.72a7.25,7.25,0,0,0,2.3,1.53,6.05,6.05,0,0,0,4.52-.38C229.31,159.89,228.26,160.24,228.26,160.24Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M257.89,107s-5.61-4.44-9.79-1.46a5.76,5.76,0,0,1,2.09,1.46,3.63,3.63,0,0,0,1.26,1.14A9.49,9.49,0,0,1,257.89,107Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff",
    opacity: 0.1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.78,142.36a5.62,5.62,0,0,0-.82,2.41c-4-3.19-1.29-9.81-1.29-9.81a9.55,9.55,0,0,0,2.86,5.89A3.56,3.56,0,0,1,146.78,142.36Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.61,153.6l1.3-6.22a13,13,0,0,0,.9,1.56,11.23,11.23,0,0,1-1.2,4.78A9.36,9.36,0,0,0,197.61,153.6Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.29,155.82c-.17.22-.36.45-.55.67a18.36,18.36,0,0,1-4,3.32c-.4.27-.83.52-1.27.76-9.7,5.34-25.78,6.18-36.08,1.1a22,22,0,0,1,4.18-7.06c7.11-8.06,19-9.7,29.19-4.84a29.43,29.43,0,0,1,6.83,4.52C196.15,154.79,196.73,155.29,197.29,155.82Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,156.24a2.52,2.52,0,0,1-.4-.4,5.79,5.79,0,0,0-1.52-1.21c-.2-.11-.42-.22-.63-.31a8.65,8.65,0,0,0-2-.6,9.36,9.36,0,0,0-1-.12l1.3-6.22a13,13,0,0,0,.9,1.56c.46.7,1.05,1.38,1.6,1.39a.68.68,0,0,0,.44-.18,1.11,1.11,0,0,0,.29-.36l.26-.42c1-1.44,1.64-.54,1.64-.54,2.57.93,1.74,6.64,1.74,6.64S204.78,157.62,203.17,156.24Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.25,154.63c-.2-.11-.42-.22-.63-.31.26-1.1.58-2.87.79-4a.68.68,0,0,0,.44-.18Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,156.24a7.28,7.28,0,0,0,.84-2.62,6.11,6.11,0,0,0-1.61-4.25c1-1.44,1.64-.54,1.64-.54,2.57.93,1.74,6.64,1.74,6.64S204.78,157.62,203.17,156.24Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,156.24a7.28,7.28,0,0,0,.84-2.62,6.11,6.11,0,0,0-1.61-4.25c1-1.44,1.64-.54,1.64-.54,2.57.93,1.74,6.64,1.74,6.64S204.78,157.62,203.17,156.24Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,144.77c-4-3.19-1.29-9.81-1.29-9.81a9.55,9.55,0,0,0,2.86,5.89,3.56,3.56,0,0,1-.75,1.51A5.62,5.62,0,0,0,146,144.77Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  }))), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M197.56,155.26l-.4.44a18.35,18.35,0,0,1-3.6,2.88l-.38.24c-.29.18-.59.35-.89.52-9.79,5.38-26.07,6.19-36.35,1a20.33,20.33,0,0,1-4.32-2.88c-11.11-9.79-13-25.81-4.2-35.79,7.12-8.06,19-9.7,29.2-4.83.32.15.63.3.95.47a29.75,29.75,0,0,1,5.88,4,82.48,82.48,0,0,1,10.57,11c.65.83,1.27,1.67,1.84,2.51.16.22.3.46.45.68.28.41.54.83.79,1.25s.39.67.58,1a19.59,19.59,0,0,1,2.95,10,11.23,11.23,0,0,1-1.2,4.78A12.51,12.51,0,0,1,197.56,155.26Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M204,155a2.52,2.52,0,0,1-.4-.4,5.59,5.59,0,0,0-1.52-1.21,5.25,5.25,0,0,0-.63-.31,8.65,8.65,0,0,0-2-.6,9.36,9.36,0,0,0-1-.12l1.3-6.22a13,13,0,0,0,.9,1.56c.46.7,1.05,1.38,1.6,1.39a.73.73,0,0,0,.44-.18,1.23,1.23,0,0,0,.29-.36c.09-.16.18-.3.26-.42,1-1.45,1.64-.54,1.64-.54,2.57.93,1.74,6.64,1.74,6.64S205.6,156.39,204,155Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M202.07,153.4a5.25,5.25,0,0,0-.63-.31c.26-1.1.58-2.87.79-4a.73.73,0,0,0,.44-.18Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M204,155a7.28,7.28,0,0,0,.84-2.62,6.11,6.11,0,0,0-1.61-4.25c1-1.45,1.64-.54,1.64-.54,2.57.93,1.74,6.64,1.74,6.64S205.6,156.39,204,155Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M204,155a7.28,7.28,0,0,0,.84-2.62,6.11,6.11,0,0,0-1.61-4.25c1-1.45,1.64-.54,1.64-.54,2.57.93,1.74,6.64,1.74,6.64S205.6,156.39,204,155Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M145.49,133.73s-2.73,6.61,1.29,9.82a5.8,5.8,0,0,1,.82-2.42,3.68,3.68,0,0,0,.76-1.52A9.48,9.48,0,0,1,145.49,133.73Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff",
    opacity: 0.1
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.4,89.12a3.5,3.5,0,0,1-1.68.24,5.76,5.76,0,0,0-2.45.68c.37-5.12,7.38-6.6,7.38-6.6A9.54,9.54,0,0,0,186.4,89.12Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.31,135.47c.49.74.95,1.49,1.37,2.25a22.87,22.87,0,0,1-2.78-1.2c-7.18-3.63-14.3-11.39-18.28-19.72a29.38,29.38,0,0,1,6.83,4.51,82.48,82.48,0,0,1,10.57,11C194.84,133.33,195.61,134.39,196.31,135.47Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.21,136.85a11.43,11.43,0,0,1-4.62,1.72,7.28,7.28,0,0,0-.47-.9l5.88-2.45A12.69,12.69,0,0,0,209.21,136.85Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.19,145.46s-2.33.39-2.11-1.71a3.07,3.07,0,0,1,.11-.56,5.84,5.84,0,0,0,.14-1.94,5.21,5.21,0,0,0-.1-.69,8.17,8.17,0,0,0-.64-2,7.28,7.28,0,0,0-.47-.9l5.88-2.45a12.69,12.69,0,0,0-.79,1.63c-.32.79-.54,1.65-.24,2.11a.72.72,0,0,0,.4.26,1.23,1.23,0,0,0,.45,0l.5,0c1.77,0,1.37,1,1.37,1C212.38,142.93,207.19,145.46,207.19,145.46Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.37,139.22l-4,2a5.21,5.21,0,0,0-.1-.69c1.06-.41,2.7-1.14,3.74-1.6A.72.72,0,0,0,209.37,139.22Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.19,145.46s-2.33.39-2.11-1.71a7.44,7.44,0,0,0,2.64-.79,6.09,6.09,0,0,0,2.6-3.72c1.77,0,1.37,1,1.37,1C212.38,142.93,207.19,145.46,207.19,145.46Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.19,145.46s-2.33.39-2.11-1.71a7.44,7.44,0,0,0,2.64-.79,6.09,6.09,0,0,0,2.6-3.72c1.77,0,1.37,1,1.37,1C212.38,142.93,207.19,145.46,207.19,145.46Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.4,89.12a3.5,3.5,0,0,1-1.68.24,5.76,5.76,0,0,0-2.45.68c.37-5.12,7.38-6.6,7.38-6.6A9.54,9.54,0,0,0,186.4,89.12Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  }))), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M209.62,136.24A11.41,11.41,0,0,1,205,138a12.43,12.43,0,0,1-3.34,0,17.35,17.35,0,0,1-4.56-1.24c-.6-.24-1.19-.51-1.78-.81l-.12-.06c-6.83-3.49-13.59-10.71-17.63-18.58-2.75-5.36-4.24-11-3.62-16,1.82-14.69,14-25.28,27.18-23.65s22.42,14.86,20.6,29.55a82.36,82.36,0,0,1-3.1,14.93c-.13.43-.27.85-.42,1.27C216.27,129,213.51,133.74,209.62,136.24Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M209.62,136.24A11.41,11.41,0,0,1,205,138a12.43,12.43,0,0,1-3.34,0,17.35,17.35,0,0,1-4.56-1.24c-.6-.24-1.19-.51-1.78-.81l-.12-.06c-6.83-3.49-13.59-10.71-17.63-18.58-2.75-5.36-4.24-11-3.62-16,1.82-14.69,14-25.28,27.18-23.65s22.42,14.86,20.6,29.55a82.36,82.36,0,0,1-3.1,14.93c-.13.43-.27.85-.42,1.27C216.27,129,213.51,133.74,209.62,136.24Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M207.6,144.85s-2.33.39-2.11-1.72a3.24,3.24,0,0,1,.11-.56,5.78,5.78,0,0,0,.14-1.93,5.36,5.36,0,0,0-.1-.7,8.32,8.32,0,0,0-.64-2,7.28,7.28,0,0,0-.47-.9l5.88-2.45a13.24,13.24,0,0,0-.79,1.64c-.32.78-.54,1.65-.24,2.1a.73.73,0,0,0,.4.27,1.26,1.26,0,0,0,.45,0l.5,0c1.77,0,1.37,1,1.37,1C212.79,142.32,207.6,144.85,207.6,144.85Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M209.78,138.61l-4,2a5.36,5.36,0,0,0-.1-.7c1.06-.41,2.7-1.14,3.74-1.6A.73.73,0,0,0,209.78,138.61Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M207.6,144.85s-2.33.39-2.11-1.72a7,7,0,0,0,2.64-.79,6.06,6.06,0,0,0,2.6-3.72c1.77,0,1.37,1,1.37,1C212.79,142.32,207.6,144.85,207.6,144.85Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M207.6,144.85s-2.33.39-2.11-1.72a7,7,0,0,0,2.64-.79,6.06,6.06,0,0,0,2.6-3.72c1.77,0,1.37,1,1.37,1C212.79,142.32,207.6,144.85,207.6,144.85Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M190.05,82.82s-7,1.49-7.37,6.61a5.62,5.62,0,0,1,2.46-.68,3.64,3.64,0,0,0,1.67-.24A9.57,9.57,0,0,1,190.05,82.82Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff",
    opacity: 0.1
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M283.23,196.21c-8.69,10.06-24.82,10.37-36,.69-5.44-4.7-11.06-10.44-14.39-16.25a19.61,19.61,0,0,1-3-10,11.41,11.41,0,0,1,1.13-4.79,13.1,13.1,0,0,1,1.85-2.79,22.92,22.92,0,0,1,8.9-5.87c11.52-4.57,28.54-4.08,37,3.26C289.88,170.15,291.92,186.15,283.23,196.21Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M230.68,172.23a12.13,12.13,0,0,0-.91-1.57c-.48-.7-1.07-1.37-1.61-1.37a.63.63,0,0,0-.45.18,1.62,1.62,0,0,0-.29.36,4.06,4.06,0,0,1-.26.43c-1,1.46-1.63.56-1.63.56-2.58-.91-1.8-6.63-1.8-6.63s1-2.16,2.6-.8a3.06,3.06,0,0,1,.41.4,5.59,5.59,0,0,0,1.53,1.2,6.09,6.09,0,0,0,.63.3,9.09,9.09,0,0,0,2,.58,8.22,8.22,0,0,0,1,.11Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M228.16,169.29a.63.63,0,0,0-.45.18l.56-4.48a6.09,6.09,0,0,0,.63.3C228.65,166.4,228.35,168.17,228.16,169.29Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M227.16,170.26c-1,1.46-1.63.56-1.63.56-2.58-.91-1.8-6.63-1.8-6.63s1-2.16,2.6-.8a7.09,7.09,0,0,0-.8,2.63A6.08,6.08,0,0,0,227.16,170.26Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M227.16,170.26c-1,1.46-1.63.56-1.63.56-2.58-.91-1.8-6.63-1.8-6.63s1-2.16,2.6-.8a7.09,7.09,0,0,0-.8,2.63A6.08,6.08,0,0,0,227.16,170.26Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M285,184.1s2.66-6.65-1.38-9.81a5.78,5.78,0,0,1-.81,2.43,3.6,3.6,0,0,0-.74,1.52A9.48,9.48,0,0,1,285,184.1Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff",
    opacity: 0.1
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M232.81,180.65a19.61,19.61,0,0,1-3-10c-.48-.7-1.07-1.37-1.61-1.37a.63.63,0,0,0-.45.18,1.62,1.62,0,0,0-.29.36,4.06,4.06,0,0,1-.26.43c-1,1.46-1.63.56-1.63.56-2.58-.91-1.8-6.63-1.8-6.63s1-2.16,2.6-.8a3.06,3.06,0,0,1,.41.4,5.59,5.59,0,0,0,1.53,1.2,6.09,6.09,0,0,0,.63.3,9.09,9.09,0,0,0,2,.58,13.1,13.1,0,0,1,1.85-2.79,22.92,22.92,0,0,1,8.9-5.87C240.29,166.07,237.68,175.4,232.81,180.65Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M218.78,183.71a15.72,15.72,0,0,1-2.15-.48c-.64-.18-1.27-.4-1.91-.65l-.41-.17c-.53-.23-1.08-.49-1.61-.76s-.81-.43-1.22-.66c-7.61-4.39-15-13.21-18.3-22.17a29.3,29.3,0,0,1-1.79-7.62,20.47,20.47,0,0,1,.06-4.15,29.34,29.34,0,0,1,3.75-11.2c.22-.36.43-.71.66-1.06,5-7.71,13.41-12.37,22.35-11.44-1.94,5.61-4.7,10.39-8.59,12.89-.32.78-.54,1.65-.24,2.1a.73.73,0,0,0,.4.27,1.26,1.26,0,0,0,.45,0l.5,0c1.77,0,1.37,1,1.37,1,.69,2.65-4.5,5.18-4.5,5.18s-2.33.39-2.11-1.72a3.24,3.24,0,0,1,.11-.56,5.78,5.78,0,0,0,.14-1.93,5.36,5.36,0,0,0-.1-.7,8.32,8.32,0,0,0-.64-2,12.43,12.43,0,0,1-3.34,0,17.35,17.35,0,0,1-4.56-1.24c.21.33.39.67.58,1a19.59,19.59,0,0,1,2.95,10c.46.7,1.05,1.38,1.6,1.39a.73.73,0,0,0,.44-.18,1.23,1.23,0,0,0,.29-.36c.09-.16.18-.3.26-.42,1-1.45,1.64-.54,1.64-.54,2.57.93,1.74,6.64,1.74,6.64s-1,2.15-2.61.77a2.52,2.52,0,0,1-.4-.4,5.59,5.59,0,0,0-1.52-1.21,5.25,5.25,0,0,0-.63-.31,8.65,8.65,0,0,0-2-.6,12.51,12.51,0,0,1-1.87,2.77l-.4.44.13.12a78.17,78.17,0,0,1,8.87,9.44c.82,1.05,1.6,2.11,2.29,3.19.49.74,1,1.49,1.38,2.24a19.7,19.7,0,0,1,2.94,10c.46.7,1,1.38,1.6,1.39a.73.73,0,0,0,.44-.18,1.23,1.23,0,0,0,.29-.36c.1-.16.18-.3.27-.43,1-1.44,1.63-.53,1.63-.53C218.14,181,218.61,182.34,218.78,183.71Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.39,133.69a3.6,3.6,0,0,1-1.68.23,5.83,5.83,0,0,0-2.46.68c.38-5.11,7.38-6.59,7.38-6.59A9.49,9.49,0,0,0,207.39,133.69Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.3,152.33c-.12,1-.27,2.09-.43,3.15-4.55,1.39-8.91,1.82-12.56.66-.81.26-1.61.65-1.76,1.16a.63.63,0,0,0,0,.48,1.19,1.19,0,0,0,.27.37,4.94,4.94,0,0,1,.33.37c1.12,1.37.07,1.72.07,1.72-1.6,2.23-6.86-.15-6.86-.15s-1.79-1.55,0-2.72a3.87,3.87,0,0,1,.5-.27,5.94,5.94,0,0,0,1.59-1.13c.16-.17.32-.34.46-.52a8.94,8.94,0,0,0,1.13-1.76,12.68,12.68,0,0,1-2.15-2.56c-4.23-6.61-4.15-18.23-.8-28.3C235.08,124.68,244.1,137.79,242.3,152.33Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.19,181.41a11.38,11.38,0,0,1-4.61,1.72,7.28,7.28,0,0,0-.47-.9l5.88-2.44A13,13,0,0,0,230.19,181.41Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.18,190s-2.34.39-2.11-1.72a3.16,3.16,0,0,1,.1-.56,5.53,5.53,0,0,0,.14-1.93,5.36,5.36,0,0,0-.09-.7,9,9,0,0,0-.64-2,7.28,7.28,0,0,0-.47-.9l5.88-2.44a13,13,0,0,0-.8,1.62c-.31.79-.53,1.66-.23,2.11a.63.63,0,0,0,.39.27,1.13,1.13,0,0,0,.46,0l.5,0c1.77,0,1.37,1,1.37,1C233.36,187.5,228.18,190,228.18,190Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.35,183.79l-4,2q0-.34-.09-.69c1.05-.41,2.7-1.14,3.74-1.6A.63.63,0,0,0,230.35,183.79Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.17,190s-2.33.39-2.11-1.72a6.94,6.94,0,0,0,2.64-.79,6.08,6.08,0,0,0,2.61-3.72c1.77,0,1.37,1,1.37,1C233.36,187.5,228.17,190,228.17,190Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.17,190s-2.33.39-2.11-1.72a6.94,6.94,0,0,0,2.64-.79,6.08,6.08,0,0,0,2.61-3.72c1.77,0,1.37,1,1.37,1C233.36,187.5,228.17,190,228.17,190Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.39,133.69a3.6,3.6,0,0,1-1.68.23,5.83,5.83,0,0,0-2.46.68c.38-5.11,7.38-6.59,7.38-6.59A9.49,9.49,0,0,0,207.39,133.69Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  }))), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M240.87,153.16C239.06,167.85,234,185.6,220.8,184s-29.52-22-27.71-36.72,14-25.28,27.18-23.65S242.69,138.46,240.87,153.16Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M226.74,190.85s-2.34.39-2.11-1.72a4.78,4.78,0,0,1,.1-.56,5.54,5.54,0,0,0,.15-1.93c0-.24-.06-.47-.1-.69a9.08,9.08,0,0,0-1.11-2.9l5.88-2.44s-1.66,2.79-1,3.73a.66.66,0,0,0,.4.27,1.06,1.06,0,0,0,.45,0l.5,0c1.77,0,1.37,1,1.37,1C231.93,188.32,226.74,190.85,226.74,190.85Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M228.92,184.61l-4,2c0-.24-.06-.47-.1-.69,1.06-.42,2.7-1.14,3.74-1.61A.66.66,0,0,0,228.92,184.61Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M226.74,190.85s-2.34.39-2.11-1.72a7.2,7.2,0,0,0,2.64-.78,6.11,6.11,0,0,0,2.6-3.73c1.77,0,1.37,1,1.37,1C231.93,188.32,226.74,190.85,226.74,190.85Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#A2FADD"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M226.74,190.85s-2.34.39-2.11-1.72a7.2,7.2,0,0,0,2.64-.78,6.11,6.11,0,0,0,2.6-3.73c1.77,0,1.37,1,1.37,1C231.93,188.32,226.74,190.85,226.74,190.85Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M209.19,128.83s-7,1.48-7.38,6.6a5.69,5.69,0,0,1,2.47-.68,3.48,3.48,0,0,0,1.67-.24A9.46,9.46,0,0,1,209.19,128.83Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff",
    opacity: 0.1
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M226.38,185.93a4.27,4.27,0,0,0-3.79,5.25c.88,2.94,4.5,3.88,6.86,5.85s3.49,5.12,3.78,8.19a20.06,20.06,0,0,1-5.77,15.87c-2.12,2.1-4.68,3.7-6.78,5.82a34.63,34.63,0,0,0-5.84,8.92,20.76,20.76,0,0,0-2.59,7.49c-.35,4.22,1.77,8.24,4.3,11.63s5.56,6.43,7.52,10.18a21.36,21.36,0,0,1,1.22,16.76,2,2,0,0,1-.71,1.13.79.79,0,0,1-1.15-.25",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M214.08,185.19a2,2,0,0,0-.08,2.55,3.15,3.15,0,0,0,2.44,1.13c1.13,0,2.39-.35,3.32.3a2.91,2.91,0,0,1,1,2.18,11.14,11.14,0,0,0,.25,2.45,4.75,4.75,0,0,0,1.08,1.75,5.41,5.41,0,0,0,2,1.46c1.66.65,3.6.07,5.3.61,2.26.71,3.47,3.13,4.15,5.4a15.55,15.55,0,0,1,.49,8.38,28.92,28.92,0,0,1-2.27,5.13,11.59,11.59,0,0,0-1.48,5.37,4.92,4.92,0,0,0,2.82,4.49",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M301,285.23l-1.88,1.13,2.54,9.2s.84.48,2.05,1.28c2.24,1.47,5.74,4,7.59,6.73,2.87,4.14,15.64,15.76,14,10.92s-2.36-3.93-2.36-3.93,2.8-7.31-4.1-10.6c-5.24-2.5-12.84-9.7-16.19-13C301.66,285.89,301,285.23,301,285.23Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#efb7b9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M339.07,309.84a16.43,16.43,0,0,1,2.87,3.69,5.51,5.51,0,0,1,.4,4.53c-.34.81-.92,1.5-1.27,2.3-1.67,3.86,2.67,8.08,1.85,12.21-.5,2.55-2.8,4.27-4.78,6s-3.93,4-3.4,6.58a14,14,0,0,0,1.6,3.33,3.61,3.61,0,0,1,.2,3.53c-1.16,1.79-4.56,1.49-5,3.57-.44,1.86,2.12,3.77,1.1,5.37a2.32,2.32,0,0,1-2.52.7,18.48,18.48,0,0,0-2.69-.73,3.31,3.31,0,0,0-3.13,4.91c.53.95,1.55,1.76,1.43,2.83a2.23,2.23,0,0,1-1.23,1.58,4.65,4.65,0,0,1-6.17-1.84c-.84-1.63-.6-3.59-.49-5.42s0-3.89-1.31-5.18a8.51,8.51,0,0,0-2.22-1.35,23.34,23.34,0,0,1-6.14-4.43c-1.58-1.59-3-3.61-2.86-5.84.15-2.53,2.26-4.71,2.09-7.23s-2.71-4.39-4.86-5.93-4.4-3.91-3.7-6.46c.76-2.75,4.32-3.56,6.08-5.8a7.68,7.68,0,0,0,1.32-2.94c.47-1.86.59-3.79,1-5.65a8,8,0,0,1,2.89-4.83c1.9-1.31,4.42-1.22,6.7-.88s4.63.89,6.87.35c1.67-.41,3.18-1.4,4.87-1.7a6.34,6.34,0,0,1,5.63,2.05c.8.87.8,1.1,1.92,1.22A4,4,0,0,1,339.07,309.84Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#925978"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336,352.49a8.61,8.61,0,0,1-2.72,1.38A8.28,8.28,0,0,1,336,352.49Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.22,361a3.16,3.16,0,0,0-1.14.14,3.38,3.38,0,0,1,2.61-1,18.14,18.14,0,0,1,2.69.73,3.47,3.47,0,0,0,1.11.07.54.54,0,0,1-.05.11,2.35,2.35,0,0,1-2.52.7A18.6,18.6,0,0,0,327.22,361Z",
    transform: "translate(-32.15 -21.57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.55,311.34c-.45,1.87-.57,3.8-1,5.66a7.68,7.68,0,0,1-1.32,2.94c-1.76,2.24-5.33,3.05-6.08,5.8-.7,2.55,1.54,4.91,3.69,6.45s4.68,3.29,4.86,5.93-1.93,4.71-2.08,7.23c-.14,2.23,1.28,4.26,2.86,5.85a23.4,23.4,0,0,0,6.14,4.43,8,8,0,0,1,2.21,1.35c1.32,1.28,1.44,3.34,1.32,5.17s-.35,3.79.49,5.43a4.69,4.69,0,0,0,5.42,2.16,3.24,3.24,0,0,1-.72.56,4.65,4.65,0,0,1-6.17-1.84c-.84-1.64-.6-3.59-.49-5.43s0-3.89-1.32-5.17a8,8,0,0,0-2.21-1.35,23.57,23.57,0,0,1-6.14-4.43c-1.58-1.59-3-3.62-2.86-5.85.15-2.52,2.26-4.7,2.09-7.23s-2.71-4.38-4.86-5.93-4.4-3.9-3.7-6.45c.76-2.75,4.32-3.56,6.08-5.8a7.68,7.68,0,0,0,1.32-2.94c.47-1.86.59-3.79,1-5.66A8,8,0,0,1,310,307.4a5.8,5.8,0,0,1,1.07-.57A8.32,8.32,0,0,0,308.55,311.34Z",
    transform: "translate(-32.15 -21.57)"
  }))), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M262.55,335.78l-2.05-2.85s-3.74,5.31,1.68,8.64S262.55,335.78,262.55,335.78Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#4c4981"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M262.55,335.78l-2.05-2.85s-3.74,5.31,1.68,8.64S262.55,335.78,262.55,335.78Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M244.79,424.7s-.36,5.34-1.2,10.54c-.6,3.72-1.45,7.38-2.59,8.94-2.73,3.77-2.13,16-2.13,16l-3.4,13.89c.25,2.82-1.69,6.51-2.61,8.07-.27.47-.46.75-.46.75l2.37,4,3.82.95s6.55-2.18,4.59-6.49a6.59,6.59,0,0,1-.44-2.73c0-5.57,3.69-14.94,3.69-14.94s9-17.16,8.06-20.68a6.53,6.53,0,0,1-.19-1.16c-.28-3.9,2-10.64,2-10.64Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#efb7b9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M185.9,399.05c-6.18,4-16.73,14.61-18.68,17.39-2.42,3.45-8.55,7.37-8.55,7.37l-4.32,2.59a5.65,5.65,0,0,0-1.49,1.43,10.59,10.59,0,0,0-.67,1l6.22,7.25s1.71-1.32,3.6-3,4.19-4,4.77-5.49c1.12-2.92,8.07-6.31,8.07-6.31s12.89-7.63,14.37-8.9a25.59,25.59,0,0,1,4.63-3.11c.88-.48,1.9-1,3.08-1.51a71,71,0,0,0,9.55-5.73l-6-9-11,4.49A7.92,7.92,0,0,0,185.9,399.05Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#efb7b9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M232.86,482.15c-.27.47-.46.75-.46.75l2.37,4,3.82.95s6.55-2.18,4.59-6.49a6.59,6.59,0,0,1-.44-2.73c-2,.47-2.69,3.27-2.69,3.27s-.26,1.16-3.32,2.24C234.66,484.83,233.45,483.22,232.86,482.15Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M232.28,481.86c-.9.72-1.25,4-1.38,6.25-.07,1.1-.09,1.95-.09,2.12,0,.51,3.4,1.66,5.52,1.09s10.62,2,10.62,2a24.08,24.08,0,0,0,8.59-1.41c2.8-1,2.51-2.23,1.34-3.26a9.67,9.67,0,0,0-3.07-1.65,7.35,7.35,0,0,1-3.1-2.52,17.66,17.66,0,0,0-4-3.82c-1.38-.92-2.93-1.73-3.92-1.56-2.16.35-2.85,3.3-2.85,3.3s-.26,1.15-3.31,2.24S232.36,481.79,232.28,481.86Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M230.9,488.11c-.07,1.1-.09,1.95-.09,2.12,0,.51,3.4,1.66,5.52,1.09s10.62,2,10.62,2a24.08,24.08,0,0,0,8.59-1.41c2.8-1,2.51-2.23,1.34-3.26-2.24.72-6.65,2-9.3,1.83C244.42,490.34,233.78,488.59,230.9,488.11Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M153.05,427.84h-.19a10.59,10.59,0,0,0-.67,1l6.22,7.25s1.71-1.32,3.6-3c-.51-3.72-8.37-5.94-8.37-5.94Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M146.58,430s.59,8.05,2.34,11c1.32,2.26,2.47,1.88,4.68.73.7-.37,1.51-.81,2.47-1.28,4-1.92,4.07-3.89,4.07-3.89,5.82-5.69-6.87-9.28-6.87-9.28l-.59.73a9,9,0,0,0-4.15.88A12.1,12.1,0,0,0,146.58,430Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M146.58,430s.59,8.05,2.34,11c1.32,2.26,2.47,1.88,4.68.73a8,8,0,0,1-4.11-5,24.74,24.74,0,0,1-1-7.86A12.1,12.1,0,0,0,146.58,430Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M301,321.63l-10.78,7.91L288,331.17l1.56,5.33,1.61,5.5,4.52,4.77s6.08-.76,9.55-3.83a6.49,6.49,0,0,0,2.32-4.12,6.24,6.24,0,0,1,.37-1.46,5.31,5.31,0,0,1,.91-1.49,6.1,6.1,0,0,1,1.68-1.31c3.1-1.69,7.51-1.18,7.51-1.18s-1.13-13.8-3.37-11.71c-1.45,1.36-5.17,1-7.61.52-1.32-.24-2.27-.5-2.27-.5Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#efb7b9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.57,
    cy: 304.36,
    r: 11.38,
    opacity: 0.1
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 288.93,
    cy: 304.14,
    r: 11.38,
    fill: "#efb7b9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M261.64,339.64c-2.09,1.5-4.73,5.33-4.73,5.33l2.77,16.13,15.38,5.68.06,0c.88-.76,12-10.33,16.42-8.83,4.59,1.57,13.38-3.61,13.38-3.61s3.72-7.81,4.71-9.49-.81-8.93-.81-8.93c-.31.54-.61,1-.91,1.49a14,14,0,0,1-2.8,3.19,5.81,5.81,0,0,1-3.89,1.53,4.27,4.27,0,0,0-1.13.06c-5.47,1-7-4.46-7.44-6.74-.1-.58-.13-1-.13-1l-2.32-4.9-1.46-3.07s-23.93,12.11-26,12.62A3.27,3.27,0,0,0,261.64,339.64Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M307.9,337.36h0a15.27,15.27,0,0,1-1,1.37l3,5a16.56,16.56,0,0,0-.22-3.44Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#925978"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M306.15,339.58a11.83,11.83,0,0,1-1.07,1l-.13.1,3.64,6.07c.34-.68.64-1.26.87-1.65Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M302.62,341.91l4.57,7.64c.28-.58.57-1.15.84-1.7l-3.95-6.58A6.08,6.08,0,0,1,302.62,341.91Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M299.71,342.21l6.1,10.18.83-1.71-5.15-8.58h-.29a4.74,4.74,0,0,0-1.13.07Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M304.89,354.3l-.74.45,0,0-7.81-13a4.94,4.94,0,0,0,2.2.58l6.75,11.25Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M287.55,327.08l5.11,8.52,0-.18c-.11-.59-.14-1-.14-1l-2.32-4.89-1.46-3.07Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#925978"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M285.18,328.27l16.58,27.64c.53-.24,1-.48,1.44-.69l-16.59-27.67Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M282.81,329.45l16.48,27.49q.78-.29,1.5-.6l-16.55-27.6Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M280.44,330.64l16.26,27.12c.53-.13,1.06-.29,1.58-.46l-16.41-27.37Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M278.07,331.82l15.82,26.38a11.77,11.77,0,0,0,1.73-.2l-16.13-26.89Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M275.69,333l14.85,24.76a3.34,3.34,0,0,1,1,.16,5.06,5.06,0,0,0,1.12.24l-15.51-25.87Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M273.31,334.17l14.48,24.16a10,10,0,0,1,1.59-.46l-14.64-24.4Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M270.93,335.33l14.44,24.1c.49-.26,1-.49,1.44-.7l-14.45-24.09Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#925978"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M268.53,336.49l14.56,24.27c.45-.29.91-.56,1.36-.82L270,335.8Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#925978"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M266.13,337.63l14.76,24.6c.42-.3.87-.6,1.31-.9L267.58,337Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#925978"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M263.71,338.72l15,25.08,1.28-1-14.85-24.77Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#925978"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M261.61,339.66l-.29.22,15.33,25.57c.36-.3.79-.64,1.25-1L262.7,339.1h0A3.12,3.12,0,0,0,261.61,339.66Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M260.52,340.59c-.38.37-.77.78-1.14,1.2l14.81,24.69.85.32,0-.05.74-.63Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M258.66,342.64c-.4.49-.76,1-1,1.34l12.61,21,2.38.88Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M256.94,344.91l-.05.08.7,4.09,8.68,14.48,2.38.88Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "225.93 330.38 226.68 334.71 230.16 340.52 232.54 341.4 225.93 330.38",
    fill: "#925978"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "227.17 337.58 227.51 339.54 228.58 339.94 227.17 337.58",
    fill: "#925978"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M261.64,339.64c.77,2.43,1.59,4.63,1.59,4.63l5.67,11.81,12.55-5.43a19.45,19.45,0,0,0,1.08-6.23c-.18-2.4,1-5.83,7-7.92.35-.12.71-.24,1.1-.35a13.13,13.13,0,0,0,2-.75,11.5,11.5,0,0,0,6.28-6.68l.08-.25,8.24-5.91a3,3,0,0,0-.22-.37c-1.32-.24-2.27-.5-2.27-.5l-3.78-.06-10.78,7.91-1.46-3.07s-23.93,12.11-26,12.62A3.27,3.27,0,0,0,261.64,339.64Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M281.66,314.66a11.19,11.19,0,0,1-4.27,6.06c-3.49,2.51-3,3.94-3,3.94L264.06,331s-1.79,2.41-3.56,2,2.51,11,2.51,11l5.67,11.81,12.55-5.43a19.45,19.45,0,0,0,1.08-6.23c-.19-2.54,1.09-6.23,8.11-8.26a11.86,11.86,0,0,0,8.29-7.44c.05-.16.07-.25.07-.25l8.25-5.91a4.6,4.6,0,0,0-3.11-2.32,10.93,10.93,0,0,1-1.33-.28c-1.21-.36-1.78-1-1.77-2.1,0-1.51-.06-8-2.85-8.2S281.66,314.66,281.66,314.66Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#4c4981"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M302.59,319.59l-5.24,4.7,1.36,4.06c.05-.16.07-.25.07-.25l8.25-5.91a4.6,4.6,0,0,0-3.11-2.32A10.93,10.93,0,0,1,302.59,319.59Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#4c4981"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M302.59,319.59l-5.24,4.7,1.36,4.06c.05-.16.07-.25.07-.25l8.25-5.91a4.6,4.6,0,0,0-3.11-2.32A10.93,10.93,0,0,1,302.59,319.59Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M301,285.23l-1.88,1.13,2.54,9.2s.84.48,2.05,1.28c-.21-1-1.13-5.72-1.41-8.29-.1-.94-.12-1.59,0-1.68s.2,0,.37.07C301.66,285.89,301,285.23,301,285.23Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M283.67,280.69s-3.18,13.07-1.74,19.68c0,0,1.2,9.67-.27,14.29l15.75-2.45.56-2.92s-2.82-2-3.28-4.52-1.24-5.24-1.24-5.24a41.81,41.81,0,0,0-1-7c-.59-1.71,1.85-2,3.7-.82a4.3,4.3,0,0,1,.69.52,2.31,2.31,0,0,0,.59,3.05,6.56,6.56,0,0,0,2.2,1h0a21.6,21.6,0,0,0,3.55.63s-1.13-5.6-1.44-8.5c-.11-.94-.13-1.59,0-1.67.55-.33,4.42,3.5,4.42,3.5s.19-4.82-1.91-5.82c0,0-.33,1.38-1.46.88s-13.4-7.3-13.4-7.3S284.75,274.05,283.67,280.69Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#4c4981"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M294.56,286l1.59,5.77a4.3,4.3,0,0,1,.69.52,2.31,2.31,0,0,0,.59,3.05,6.56,6.56,0,0,0,2.2,1h0a22.73,22.73,0,0,0,3,.48s-1.13-5.6-1.45-8.49Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M295.15,286.11l1.69,6.15a2.31,2.31,0,0,0,.59,3.05c1.66,1.25,5.76,1.59,5.76,1.59s-1.13-5.6-1.44-8.5Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#4c4981"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M295.29,286l1.69,6.14a2.33,2.33,0,0,0,.58,3.06c1.67,1.25,5.77,1.58,5.77,1.58s-1.13-5.6-1.45-8.49Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff",
    opacity: 0.1
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M256.27,431.16l-11.48-6.46s-.36,5.34-1.2,10.54c3.95,2.5,7.62,4.88,10.71,6.56C254,437.9,256.27,431.16,256.27,431.16Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M185.9,399.05a35.73,35.73,0,0,0,4.76,6.33s1.16,1.61,3.19,3.86c.88-.48,1.9-1,3.08-1.51a71,71,0,0,0,9.55-5.73l-6-9-11,4.49A7.92,7.92,0,0,0,185.9,399.05Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M222.64,362.37c-2.06,3.23-12.08,14-12.08,14a55.09,55.09,0,0,0-4.52,6.83c-1.76,3.3-7.16,7.41-11.29,11.13s-4.13,1.23-6.57,2.57S193,406,193,406s12.29,17,26.22,17.72,34.29,19.11,42.75,20.94,3.21-3,6.81-4.25,5.36-5.21,5.36-5.21-1.32-9.69-.24-11.83,2.34-10.88,2.34-10.88,0-7.73.6-9,.32-10.29-.12-12.9,1.91-6.38,1.91-6.38-.83-1.38.33-4.45-1-12.88-1-12.88C260,356.34,256.91,345,256.91,345l-2.25.69C240.42,342.1,224.69,359.14,222.64,362.37Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#444053"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M254.66,345.66s1.41,15.25,23.32,21.2C260,356.34,256.91,345,256.91,345Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M257.06,371.92s-18.06,29.17-18.52,30.7S257.8,372.73,257.06,371.92Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M255.45,362.78s-13.86,20.79-16.58,21.67C238.87,384.45,252.16,364.38,255.45,362.78Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M247,357.86s-9.78,7-17.38,6.18Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M244.31,353.36s-9.39,3.91-11.76,3.7Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.7 358.55 234.41 377.84 231 372.15 233.7 358.55",
    opacity: 0.1
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M323.87,316.3c-.18,1.07-.76,2.13-.46,3.17a4.33,4.33,0,0,0,1.38,1.81c1.43,1.33,2.79,3,3,4.89.26,2.77-1.95,5.31-1.72,8.08a4.65,4.65,0,0,0,.87,2.36,4.7,4.7,0,0,0,1.1,1.08,4.61,4.61,0,0,0,3.42.75,5.9,5.9,0,0,0,4.27-4.09,12.35,12.35,0,0,0,.09-6.13c-1-5.31-3.58-10.18-6.1-15a2.34,2.34,0,0,0-.81-1c-.88-.51-4.26-.57-5.1.11C322.65,313.26,324.87,315.71,323.87,316.3Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M324.24,316.08c-.19,1.07-.76,2.13-.47,3.17a4.28,4.28,0,0,0,1.39,1.81c1.42,1.33,2.78,2.95,3,4.89.25,2.77-2,5.31-1.73,8.08a4.75,4.75,0,0,0,.88,2.36,4.47,4.47,0,0,0,1.09,1.08,4.64,4.64,0,0,0,3.43.75,5.89,5.89,0,0,0,4.26-4.09,12.23,12.23,0,0,0,.1-6.13c-1-5.31-3.58-10.18-6.1-15a2.41,2.41,0,0,0-.81-1c-.88-.51-4.26-.57-5.1.11C323,313,325.24,315.49,324.24,316.08Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#925978"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M344.32,383.23l-5.69,4.35,2.13,1.51,11.55,8.19s4,8.29,11,6-4-9.39-4.76-9.69-2.17-1.13-2.17-1.13l-10.27-7.85Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#efb7b9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M344.32,383.23l-5.69,4.35,2.13,1.51c2.69-1.71,5-3.57,5.37-4.48Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M278.79,346.5l-12.31,8,8.64,12.19c.88-.76,12-10.33,16.42-8.83,4.59,1.57,13.38-3.61,13.38-3.61s3.72-7.81,4.71-9.49-.81-8.93-.81-8.93a6.1,6.1,0,0,1,1.68-1.31,8.14,8.14,0,0,0-1.63.1c-2.43,1.07-3.67,2.76-3.76,5.89,0,.28,0,.56,0,.86,0,.48.05,1,.11,1.53l0,.25c.6,4.88-1.58,6.94-1.58,6.94a10.77,10.77,0,0,1-6.11,5C293.24,356.47,278.79,346.5,278.79,346.5Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M279.23,347.23l-12.31,8L276.64,369s4.82-2.64,6.4-4.59,9.62-5.19,9.62-5.19c9.7,3.42,13.86-2.4,13.86-2.4s11.26,17.53,12,17.61,6.84,4.88,6.84,4.88,4.72,6.07,6.1,6.57a8.69,8.69,0,0,1,1.5.68,3.07,3.07,0,0,1,.4.26l-4.13,2.4a1,1,0,0,0,.07.15l.05.08a6.67,6.67,0,0,0,2.52,2.51c1.87,1,14.08-6.61,13.88-8.32a1.86,1.86,0,0,0-.37-.88,10.33,10.33,0,0,0-3.18-2.48l-.32-.18-.12-.06s-7.06-7.08-9.35-8.12-10-13.46-10-13.46-4-5.33-3.48-6.48-2.05-10.83-3.67-11-2.34-2.39-2.34-2.39c1.07-2.25-.05-3-1.31-3.2a7.69,7.69,0,0,0-2.26,0c-2.64,1.17-3.88,3.07-3.76,6.75,0,.55.06,1.15.14,1.78.6,4.88-1.58,6.94-1.58,6.94a10.77,10.77,0,0,1-6.11,5C293.68,357.2,279.23,347.23,279.23,347.23Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#4c4981"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M345.35,382.76a1.41,1.41,0,0,1,.15.51c.2,1.71-12,9.36-13.88,8.33a6.81,6.81,0,0,1-2.3-2.15l-.05-.08a1,1,0,0,1-.07-.15l4.13-2.4a3.07,3.07,0,0,0-.4-.26l.18-.1a12.35,12.35,0,0,0,8.74-6.36Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M333.33,386.82l-4.13,2.4a6.63,6.63,0,0,0,2.64,2.74c1.87,1,14.08-6.61,13.88-8.32-.15-1.36-2.54-2.81-3.55-3.36A12.34,12.34,0,0,1,333.33,386.82Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#4c4981"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M333.33,386.82l-4.13,2.4a6.63,6.63,0,0,0,2.64,2.74c1.87,1,14.08-6.61,13.88-8.32-.15-1.36-2.54-2.81-3.55-3.36A12.34,12.34,0,0,1,333.33,386.82Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#fff",
    opacity: 0.1
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M305.55,342.14l3,1.29,3-8.07a7.69,7.69,0,0,0-2.26,0C306.67,336.56,305.43,338.46,305.55,342.14Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#4c4981"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M305.68,342.07l3,1.28,3-8.07a7.69,7.69,0,0,0-2.26,0C306.8,336.48,305.56,338.38,305.68,342.07Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M325,315.64c-.19,1.07-.77,2.13-.47,3.17a4.27,4.27,0,0,0,1.38,1.81c1.43,1.33,2.79,2.95,3,4.89.25,2.77-2,5.31-1.73,8.08A4.73,4.73,0,0,0,328,336,4.61,4.61,0,0,0,329.1,337a4.56,4.56,0,0,0,3.42.75,4.2,4.2,0,0,0,1.21-.4,4.75,4.75,0,0,1-1.94.84,4.58,4.58,0,0,1-4.52-1.82,4.82,4.82,0,0,1-.88-2.37c-.23-2.77,2-5.31,1.73-8.08-.17-1.94-1.53-3.56-3-4.89a4.22,4.22,0,0,1-1.39-1.81c-.29-1,.28-2.1.47-3.17,1-.59-1.22-3-.1-4a1.85,1.85,0,0,1,.58-.26C324,312.87,325.92,315.08,325,315.64Z",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M298.84,337.62s-3.9.27-4.37,2.29c0,0,3.74-3.61,3.22-4.55",
    transform: "translate(-32.15 -21.57)",
    opacity: 0.1
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M364.19,398s-10.08-4.83-8.72,1.24S364.19,398,364.19,398Z",
    transform: "translate(-32.15 -21.57)",
    fill: "#efb7b9"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 366.89,
    y: 355.36,
    width: 10.5,
    height: 118,
    transform: "translate(-170.68 170.52) rotate(-24.55)",
    fill: "#A2FADD"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M224.55,186.4c-1.86,4.08-6.39,7.71-5.05,12,.69,2.21,2.8,3.63,4.76,4.86,4.58,2.9,9.25,5.9,12.57,10.18s5.12,10.15,3.2,15.22c-1.31,3.47-4.15,6.15-5.81,9.47a19.85,19.85,0,0,0-1.09,13.36A46.11,46.11,0,0,0,238.62,264c.85,1.46,1.85,3,3.44,3.58a11.88,11.88,0,0,0,3.63.3c4.23.16,8.05,3,10.31,6.55s3.17,7.85,3.62,12.06c.22,2.12.38,4.37,1.58,6.13,1.68,2.46,4.88,3.27,7.82,3.77a99.06,99.06,0,0,0,23.14,1.19",
    transform: "translate(-32.15 -21.57)",
    fill: "none",
    stroke: "#444053",
    strokeMiterlimit: 10
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 248.29,
    y: 269.78,
    width: 13.75,
    height: 9.08,
    rx: 4.54,
    ry: 4.54,
    fill: "#444053"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.574b48b7ffa6cead9662c43e66111f22.svg";
export { ForwardRef as ReactComponent };